webpackJsonp([43],Array(24).concat([
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  prefix: '',
  suffix: '',
  thousands: ',',
  decimal: '.',
  precision: 2
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(49);



var moment = __webpack_require__(0);

var feedback = function feedback() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 368));
};
var confirmacao = function confirmacao() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 367));
};
var previa = function previa() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 401));
};
var alreadySent = function alreadySent() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 364));
};
var sentCanceled = function sentCanceled() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 403));
};
var scheduleInvalid = function scheduleInvalid() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 402));
};
var cancelarEnvio = function cancelarEnvio() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 366));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 362));
};
var Cadastro = function Cadastro() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 365));
};
var ValidaEmail = function ValidaEmail() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 363));
};

// Dashboard
var Expirado = function Expirado() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 386));
};
var Painel = function Painel() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 387));
};
var agendamento = {
  painel: function painel() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 379));
  },
  agendados: function agendados() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 376));
  },
  pendentes: function pendentes() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 380));
  },
  concluidos: function concluidos() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 378));
  },
  cancelados: function cancelados() {
    return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 377));
  }
};
var PInicio = function PInicio() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 388));
};
var PConta = function PConta() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 384));
};
var pedidos = {
  painel: function painel() {
    return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 397));
  },
  novos: function novos() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 398));
  },
  andamento: function andamento() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 394));
  },
  concluidos: function concluidos() {
    return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 396));
  },
  cancelados: function cancelados() {
    return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 395));
  }
};
var POrcamentos = function POrcamentos() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 393));
};
var PItens = function PItens() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 390));
};
var PNegocios = function PNegocios() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 392));
};
var PAtendimento = function PAtendimento() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 381));
};
var PRelatorios = {
  painel: function painel() {
    return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 399));
  },
  pedidos: function pedidos() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 400));
  }
  // itens: () => import('@/components/painel/relatorios/itens/')


  // Sub rotas
};var Manutencao = function Manutencao() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 375));
};
var Relacao = function Relacao() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 391));
};
var Cupons = function Cupons() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 389));
};
var Empresa = function Empresa() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 383));
};
var Avaliacoes = function Avaliacoes() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 382));
};
var Usuarios = function Usuarios() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 385));
};

var hotsite = function hotsite() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 374));
};
var Cupom = function Cupom() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 372));
};
var Checkin = function Checkin() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 369));
};
var Checkout = function Checkout() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 370));
};
var Confirm = function Confirm() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 371));
};
var Success = function Success() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 373));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
function registrationCompleted(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].getters.registrationCompleted) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('toastr', {
      color: 'info',
      texto: 'Complete seu cadastro para acessar este recurso'
    });
  } else {
    requireAuth(to, from, next);
  }
}
var resource = false;
function resourceAvaliable(to, from, next) {
  if (resource) {
    requireAuth(to, from, next);
  } else {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('toastr', {
      color: 'info',
      texto: 'Recurso não disponível'
    });
  }
}
function requireAuth(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].getters.autenticacao) {
    next();
  } else {
    var validity = getCookie('tokenValidade');
    if (validity !== '') {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('singOut', moment(validity).diff(moment()));
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('singIn', {
        nome: getCookie('tokenNome'),
        nivel: getCookie('tokenNivel'),
        token: getCookie('tokenAcesso'),
        status: getCookie('tokenStatus')
      });
      next();
    } else {
      next('/Login');
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].commit('toastr', {
        color: 'error',
        texto: 'Você não está autenticado'
      });
    }
  }
}
function singIn(to, from, next) {
  if (getCookie('tokenValidade') === '') {
    next();
  } else {
    next('/Painel/Inicio/');
  }
}
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/Login',
    name: 'Login',
    beforeEnter: singIn,
    component: Login
  }, {
    path: '/feedback/:token/:type/:send',
    name: 'feedback',
    props: true,
    component: feedback
  }, {
    path: '/confirmacao/:token/:type',
    name: 'confirmacao',
    props: true,
    component: confirmacao
  }, {
    path: '/previa/:token/:type/:send',
    name: 'previa',
    props: true,
    component: previa
  }, {
    path: '/cancelarEnvio',
    name: 'cancelarEnvio',
    component: cancelarEnvio
  }, {
    path: '/alreadySent/:token/:type',
    name: 'alreadySent',
    props: true,
    component: alreadySent
  }, {
    path: '/sentCanceled/:token/:type',
    name: 'sentCanceled',
    props: true,
    component: sentCanceled
  }, {
    path: '/scheduleInvalid/:token',
    name: 'scheduleInvalid',
    props: true,
    component: scheduleInvalid
  }, {
    path: '/Expirado',
    name: 'Expirado',
    component: Expirado,
    props: true
  }, {
    path: '/ValidaEmail/:token',
    name: 'Validação de email',
    component: ValidaEmail,
    props: true
  }, {
    path: '/',
    beforeEnter: singIn,
    component: Login
  }, {
    path: '/Cadastro',
    name: 'Cadastro Visitante',
    component: Cadastro
  }, {
    path: '/A',
    component: hotsite,
    children: [{
      path: 'Cupom/:token/:type',
      name: 'Cupom',
      props: true,
      component: Cupom
    }, {
      path: 'Servicos/:token',
      props: true,
      component: Checkin
    }, {
      path: 'Confirmar',
      component: Confirm
    }, {
      path: 'Sucesso',
      component: Success
    }, {
      path: 'Checkout/:token',
      props: true,
      component: Checkout
    }]
  }, {
    path: '/Painel',
    name: 'Painel',
    beforeEnter: requireAuth,
    component: Painel,
    children: [{
      path: 'Conta',
      component: PConta,
      children: [{
        path: 'Empresa',
        component: Empresa
      }, {
        path: 'Avaliacoes',
        component: Avaliacoes
      }, {
        path: 'Usuarios',
        component: Usuarios
      }, {
        path: 'Condominios',
        beforeEnter: resourceAvaliable,
        component: Manutencao
      }, {
        path: 'Faturamento',
        beforeEnter: resourceAvaliable,
        component: Manutencao
      }, {
        path: 'Planos',
        beforeEnter: resourceAvaliable,
        component: Manutencao
      }]
    }, {
      path: 'Inicio',
      beforeEnter: requireAuth,
      component: PInicio
    }, {
      path: 'Agendamento',
      component: agendamento.painel,
      beforeEnter: registrationCompleted,
      children: [{
        path: 'Agendados',
        component: agendamento.agendados
      }, {
        path: 'Pendentes',
        component: agendamento.pendentes
      }, {
        path: 'Realizados',
        component: agendamento.concluidos
      }, {
        path: 'Cancelados',
        component: agendamento.cancelados
      }]
    }, {
      path: 'Pedidos',
      component: pedidos.painel,
      beforeEnter: registrationCompleted,
      children: [{
        path: 'Novos',
        component: pedidos.novos
      }, {
        path: 'Andamento',
        component: pedidos.andamento
      }, {
        path: 'Concluidos',
        component: pedidos.concluidos
      }, {
        path: 'Cancelados',
        component: pedidos.cancelados
      }]
    }, {
      path: 'Orcamentos',
      beforeEnter: registrationCompleted,
      component: POrcamentos
    }, {
      path: 'Itens',
      beforeEnter: registrationCompleted,
      component: PItens,
      children: [{
        path: 'Relacao',
        component: Relacao
      }, {
        path: 'Familia',
        component: Manutencao
      }, {
        path: 'Cupons',
        component: Cupons
      }]
    }, {
      path: 'Negocios',
      beforeEnter: registrationCompleted,
      component: PNegocios
    }, {
      path: 'Atendimento',
      beforeEnter: registrationCompleted,
      component: PAtendimento
    }, {
      path: 'Relatorios',
      beforeEnter: registrationCompleted,
      component: PRelatorios.painel,
      children: [
      // {
      //   path: 'Itens',
      //   component: PRelatorios.itens
      // },
      {
        path: 'Condominios',
        component: PRelatorios.pedidos
      }]
    }]
  }]
}));

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__autenticacao__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cadastro__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detalheCadastro__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__empresa__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__agendamento__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notificacaoTabs__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__relatorios__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pedido__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__toastr__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cantAccess__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Checkin__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Checkout__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hotsite_feedback__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hotsite_confirmacao__ = __webpack_require__(268);





















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    shared: __WEBPACK_IMPORTED_MODULE_11__shared__["a" /* default */],
    autenticacao: __WEBPACK_IMPORTED_MODULE_2__autenticacao__["a" /* default */],
    agendamento: __WEBPACK_IMPORTED_MODULE_7__agendamento__["a" /* default */],
    cadastro: __WEBPACK_IMPORTED_MODULE_3__cadastro__["a" /* default */],
    detalheCadastro: __WEBPACK_IMPORTED_MODULE_4__detalheCadastro__["a" /* default */],
    empresa: __WEBPACK_IMPORTED_MODULE_5__empresa__["a" /* default */],
    feedback: __WEBPACK_IMPORTED_MODULE_16__hotsite_feedback__["a" /* default */],
    confirmacao: __WEBPACK_IMPORTED_MODULE_17__hotsite_confirmacao__["a" /* default */],
    item: __WEBPACK_IMPORTED_MODULE_6__item__["a" /* default */],
    notificacaoTabs: __WEBPACK_IMPORTED_MODULE_8__notificacaoTabs__["a" /* default */],
    report: __WEBPACK_IMPORTED_MODULE_9__relatorios__["a" /* default */],
    pedido: __WEBPACK_IMPORTED_MODULE_10__pedido__["a" /* default */],
    toastr: __WEBPACK_IMPORTED_MODULE_12__toastr__["a" /* default */],
    cantAccess: __WEBPACK_IMPORTED_MODULE_13__cantAccess__["a" /* default */],
    Checkin: __WEBPACK_IMPORTED_MODULE_14__Checkin__["a" /* default */],
    Checkout: __WEBPACK_IMPORTED_MODULE_15__Checkout__["a" /* default */]
  }
});

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assign__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(24);




/* harmony default export */ __webpack_exports__["a"] = (function (el, binding) {
  if (!binding.value) return;
  var opt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assign__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__options__["a" /* default */], binding.value);

  // v-money used on a component that's not a input
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    var els = el.getElementsByTagName('input');
    if (els.length !== 1) {
      // throw new Error("v-money requires 1 input, found " + els.length)
    } else {
      el = els[0];
    }
  }

  el.oninput = function () {
    var positionFromEnd = el.value.length - el.selectionEnd;
    if (el.value === 'R$ 0,0' || !el.value) {
      el.value = '';
    } else {
      el.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* format */])(el.value, opt);
    }
    positionFromEnd = Math.max(positionFromEnd, opt.suffix.length); // right
    positionFromEnd = el.value.length - positionFromEnd;
    positionFromEnd = Math.max(positionFromEnd, opt.prefix.length + 1); // left
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* setCursor */])(el, positionFromEnd);
    el.dispatchEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* event */])('change')); // v-model.lazy
  };

  el.onfocus = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* setCursor */])(el, el.value.length - opt.suffix.length);
  };

  el.oninput();
  el.dispatchEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* event */])('input')); // force format after initialization
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unformat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setCursor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return event; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__options__ = __webpack_require__(24);


function format(input) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__options__["a" /* default */];

  if (typeof input === 'number') {
    input = input.toFixed(fixed(opt.precision));
  }
  var negative = input.indexOf('-') >= 0 ? '-' : '';

  var numbers = onlyNumbers(input);
  var currency = numbersToCurrency(numbers, opt.precision);
  var parts = toStr(currency).split('.');
  var integer = parts[0];
  var decimal = parts[1];
  integer = addThousandSeparator(integer, opt.thousands);
  return opt.prefix + negative + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix;
}

function unformat(input, precision) {
  var negative = input.indexOf('-') >= 0 ? -1 : 1;
  var numbers = onlyNumbers(input);
  var currency = numbersToCurrency(numbers, precision);
  return parseFloat(currency) * negative;
}

function onlyNumbers(input) {
  return toStr(input).replace(/\D+/g, '') || '0';
}

// Uncaught RangeError: toFixed() digits argument must be between 0 and 20 at Number.toFixed
function fixed(precision) {
  return between(0, precision, 20);
}

function between(min, n, max) {
  return Math.max(min, Math.min(n, max));
}

function numbersToCurrency(numbers, precision) {
  var exp = Math.pow(10, precision);
  var float = parseFloat(numbers) / exp;
  return float.toFixed(fixed(precision));
}

function addThousandSeparator(integer, separator) {
  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, '$1' + separator);
}
// function currencyToIntegerAndDecimal (float) {
//   return toStr(float).split('.')
// }

function joinIntegerAndDecimal(integer, decimal, separator) {
  return decimal ? integer + separator + decimal : integer;
}

function toStr(value) {
  return value ? value.toString() : '';
}

function setCursor(el, position) {
  var setSelectionRange = function setSelectionRange() {
    el.setSelectionRange(position, position);
  };
  if (el === document.activeElement) {
    setSelectionRange();
    setTimeout(setSelectionRange, 1); // Android Fix
  }
}

// https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
function event(name) {
  var evt = document.createEvent('Event');
  evt.initEvent(name, true, true);
  return evt;
}



/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(350);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(357);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: __webpack_require__.i({"NODE_ENV":"production"}).VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: __webpack_require__.i({"NODE_ENV":"production"}).VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directive__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__options__ = __webpack_require__(24);
/* unused harmony reexport Money */
/* unused harmony reexport VMoney */
/* unused harmony reexport options */







function install(Vue, globalOptions) {
  if (globalOptions) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(globalOptions).map(function (key) {
      __WEBPACK_IMPORTED_MODULE_3__options__["a" /* default */][key] = globalOptions[key];
    });
  }
  Vue.directive('money', __WEBPACK_IMPORTED_MODULE_2__directive__["a" /* default */]);
  Vue.component('money', __WEBPACK_IMPORTED_MODULE_1__component___default.a);
}

/* harmony default export */ __webpack_exports__["a"] = (install);

// Install by default if included from script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install);
}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */,
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(353),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_calendar__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_v_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_calendar_lib_v_calendar_min_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_calendar_lib_v_calendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_calendar_lib_v_calendar_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__v_money_index__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n__ = __webpack_require__(206);








// import { EmojiPickerPlugin } from 'vue-emoji-picker'





// // Translation provided by Vuetify (javascript)
// import zhHans from 'vuetify/es5/locale/zh-Hans'

// // Translation provided by Vuetify (typescript)
// import pl from 'vuetify/src/locale/pt'

// // Your own translation file
// import sv from './i18n/vuetify/pt'

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_v_calendar___default.a, {
  componentPrefix: 'c',
  firstDayOfWeek: 1,
  locale: 'pt-br'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__v_money_index__["a" /* default */], {
  decimal: ',',
  thousands: '.',
  precision: 2,
  allowBlank: true,
  masked: false
});

// export default {
//   components: {
//     EmojiIcon
//   }
// }




__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

var url = "/api/v1/";

window.httpHeader = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
  baseURL: url,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/json',
    'Token': __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */].getters.token
  }
});

window.axios = function axiosNewToken(token) {
  window.http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
    baseURL: url,
    timeout: 200000,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Token': token
    }
  });
};

window.http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
  baseURL: url,
  timeout: 200000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

// axios.defaults.baseURL = url
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers.common['Token'] = store.getters.token

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
  baseURL: url,
  timeout: 200000,
  paramsSerializer: function paramsSerializer(params) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params);
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_7_moment___default()(String(value)).format('MM/DD/YYYY hh:mm');
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */],
  template: '<App/>',
  i18n: __WEBPACK_IMPORTED_MODULE_12__i18n__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

// Vue.component('my-component', {
//   methods: {
//     changeLocale () {
//       this.$vuetify.lang.current = 'sv'
//     }
//   }
// })

// export default new Vuetify({
//   lang: {
//     locales: { zhHans, pl, sv },
//     current: 'zhHans'
//   }
// })

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  checkEmail: function checkEmail(_ref, token) {
    var state = _ref.state,
        commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (state.email === '') {
        commit('toastr', {
          color: 'info',
          texto: 'Insira um email'
        });
        reject();
      } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(state.email)) {
        commit('toastr', {
          color: 'info',
          texto: 'Insira um email valido'
        });
        reject();
      } else {
        commit('toggleLoadingEmail', true);
        __WEBPACK_IMPORTED_MODULE_1_axios___default()({
          method: 'get',
          url: "/api/v1/" + 'Hotsite/VerifyUser?email=' + state.email,
          timeout: 200000,
          headers: {
            'Token': token
          }
        }).then(function (response) {
          commit('toggleLoadingEmail', false);
          if (response.data.resultado.haveAccess) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/a/Confirmar');
          } else {
            commit('toastr', {
              color: 'info',
              texto: 'Não foi encontrado seu email na base de dados'
            });
          }
        }).catch(function (error) {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros;
            var description = '';
            if (erros.length > 0) {
              erros.forEach(function (element) {
                description = description + ' ' + element;
              });
            } else {
              description = erros[0];
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              });
            }
          }
          commit('toggleLoadingEmail', false);
          commit('toastrAxiosError', error);
        });
      }
    });
  },
  getCupom: function getCupom(_ref2, token) {
    var state = _ref2.state,
        commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingLogo', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Fornecedor/GetDetalheHotSite',
        timeout: 200000,
        headers: {
          'Token': token
        }
      }).then(function (response) {
        commit('toggleLoadingLogo', false);
        commit('loadCupom', response.data.resultado);
        resolve();
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingLogo', false);
        commit('toastrAxiosError', error);
      });
    });
  }
  // cancelSchedule ({state, commit, rootGetters}) {
  //   return new Promise((resolve, reject) => {
  //     commit('toggleLoadingCanceled', true)
  //     axios({
  //       method: 'post',
  //       url: process.url + 'Agendamento/CancelSchedule',
  //       timeout: 200000,
  //       headers: {
  //         'Token': rootGetters.token
  //       },
  //       data: state.selectedSchedule
  //     })
  //     .then((response) => {
  //       commit('updateRegisteredSchedules', response.data.resultado)
  //       commit('toggleLoadingCanceled', false)
  //       commit('toggleScheduleDetailsModal', false)
  //     })
  //     .catch((error) => {
  //       commit('toastrAxiosError', error)
  //       commit('toggleLoadingCanceled', false)
  //     })
  //   })
  // }

});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  email: function email(state) {
    return state.email;
  },
  loadingEmail: function loadingEmail(state) {
    return state.loadingEmail;
  },
  logoProvider: function logoProvider(state) {
    return state.logo === '' ? '' : state.logo;
  },
  registerUrl: function registerUrl(state) {
    return state.registerUrl;
  },
  loadingLogo: function loadingLogo(state) {
    return state.loadingLogo;
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(234);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    email: '',
    loadingEmail: false,
    logo: '',
    registerUrl: '',
    providerUrl: '',
    loadingLogo: false
  },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  updateEmail: function updateEmail(state, value) {
    state.email = value;
  },
  loadCupom: function loadCupom(state, payload) {
    state.logo = payload.logo;
    state.registerUrl = payload.registerUrl;
    state.providerUrl = payload.providerUrl;
  },
  toggleLoadingLogo: function toggleLoadingLogo(state, value) {
    state.loadingLogo = value;
  },
  resetLogo: function resetLogo(state) {
    state.logo = '';
  },
  toggleLoadingEmail: function toggleLoadingEmail(state, value) {
    state.loadingEmail = value;
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);




var _this = this;



/* harmony default export */ __webpack_exports__["a"] = ({
  requestOrder: function requestOrder(_ref) {
    var state = _ref.state,
        commit = _ref.commit,
        getters = _ref.getters;

    if (state.acceptance === false) {
      commit('toastr', {
        color: 'info',
        time: 2500,
        texto: 'Aceite as condições do uso'
      });
      return;
    } else if (state.itemChoosen === '') {
      commit('toastr', {
        color: 'info',
        time: 2500,
        texto: 'Escolha um item'
      });
      return;
    } else if (state.timeChoosen === null) {
      commit('toastr', {
        color: 'info',
        time: 2500,
        texto: 'Escolha um horario'
      });
      return;
    } else if (getters.unity !== false && state.unityChoosen === null) {
      if (getters.unity.length > 1) {
        commit('toastr', {
          color: 'info',
          time: 2500,
          texto: 'Escolha uma unidade'
        });
        return;
      } else {
        commit('updateUnityChoosen', getters.unity[0]);
      }
    }
    var price = state.item.priceTable.filter(function (elem) {
      if (elem.provider === state.itemChoosen) {
        return elem;
      }
    });
    var order = void 0;
    if (price[0].priceVariations) {
      order = {
        itens: [{
          id: price[0].provider,
          count: 1
        }],
        timeChoosen: state.timeChoosen,
        dateChoosen: state.dateChoosen,
        unit: state.unityChoosen,
        payment: state.paymentChoosen,
        item: price[0].id
      };
    } else {
      order = {
        count: 1,
        timeChoosen: state.timeChoosen,
        unit: state.unityChoosen,
        payment: state.paymentChoosen,
        item: price[0].id
      };
    }
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingOrderRequest', true);
      __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'HotSite/SaveOrder',
        timeout: 200000,
        headers: { 'Token': getters.hotSiteToken },
        data: order
      }).then(function (response) {
        commit('toggleLoadingOrderRequest', false);
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/a/Sucesso');
        // if (response.data.resultado.success) {
        // } else {
        //   commit('toastr', {
        //     color: 'warning',
        //     texto: response.data.resultado.error
        //   })
        // }
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response);
          var description = '';
          if (erros.preErros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else if (erros.resultado) {
            description = erros.resultado;
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              time: 2500,
              texto: description
            });
          }
        }
        commit('toggleLoadingOrderRequest', false);
        commit('toastrAxiosError', error);
      });
    });
  },

  getScheduleItem: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref3) {
      var commit = _ref3.commit,
          getters = _ref3.getters;

      var _ref4, response;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("/api/v1/" + 'HotSite/ItensPorAgendamento', { headers: { 'Token': getters.hotSiteToken } });

            case 2:
              _ref4 = _context.sent;
              response = _ref4.data;

              commit('loadItem', response.resultado);
              // console.log(response.resultado)

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function getScheduleItem(_x) {
      return _ref2.apply(this, arguments);
    };
  }(),
  getAvaliableSchedule: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref6) {
      var commit = _ref6.commit,
          getters = _ref6.getters;

      var getters2, _ref7, response;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // console.log(getters.dates[0])
              getters2 = {
                dateChoosen: getters.dateChoosen !== '' ? getters.dateChoosen : getters.item.dates[0]
              };
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("/api/v1/" + 'HotSite/GetGradeHoras?date=' + getters2.dateChoosen, { headers: { 'Token': getters.hotSiteToken } });

            case 3:
              _ref7 = _context2.sent;
              response = _ref7.data;

              commit('loadAvaliableSchedule', response.resultado.times);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function getAvaliableSchedule(_x2) {
      return _ref5.apply(this, arguments);
    };
  }(),
  getClient: function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref9) {
      var commit = _ref9.commit,
          getters = _ref9.getters;

      var _ref10, response;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("/api/v1/" + 'Hotsite/GetDetalheUserByToken', { headers: { 'Token': getters.hotSiteToken } });

            case 2:
              _ref10 = _context3.sent;
              response = _ref10.data;

              commit('loadClient', response.resultado);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function getClient(_x3) {
      return _ref8.apply(this, arguments);
    };
  }(),
  choseDate: function choseDate(_ref11, payload) {
    var _this2 = this;

    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit('toggleLoadingCheckout', true);
              commit('updateDateChoosen', payload);
              _context4.next = 4;
              return dispatch('getAvaliableSchedule');

            case 4:
              commit('toggleLoadingCheckout', false);

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }))();
  },
  getAllInfo: function getAllInfo(_ref12, token) {
    var _this3 = this;

    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit('toggleLoadingCheckout', true);
              commit('setHotSiteToken', token);
              _context5.prev = 2;
              _context5.next = 5;
              return dispatch('getScheduleItem');

            case 5:
              _context5.next = 7;
              return dispatch('getAvaliableSchedule');

            case 7:
              _context5.next = 9;
              return dispatch('getClient');

            case 9:
              _context5.next = 15;
              break;

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5['catch'](2);

              commit('toastrAxiosError', _context5.t0);
              commit('toggleLoadingCheckout', false);

            case 15:
              commit('toggleLoadingCheckout', false);

            case 16:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this3, [[2, 11]]);
    }))();
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  hotSiteToken: function hotSiteToken(state) {
    return state.hotSiteToken;
  },
  avaliableSchedule: function avaliableSchedule(state) {
    return state.avaliableSchedule;
  },
  client: function client(state) {
    return state.client;
  },
  item: function item(state) {
    return state.item;
  },
  itens: function itens(state) {
    return state.itens;
  },
  loadingCheckout: function loadingCheckout(state) {
    return state.loadingCheckout;
  },
  paymentChoosen: function paymentChoosen(state) {
    return state.paymentChoosen;
  },
  priceVariation: function priceVariation(state) {
    return state.item === null ? false : state.item.priceVariation;
  },
  itemChoosen: function itemChoosen(state, getters) {
    if (state.item === null) return false;
    if (state.itemChoosen === '') {
      return state.item.priceTable[0];
    } else {
      return state.item.priceTable.filter(function (elem) {
        return elem.provider === state.itemChoosen;
      })[0];
    }
  },
  itensChoosen: function itensChoosen(state, getters) {
    return state.itensChoosen;
  },
  itemChoosenDescription: function itemChoosenDescription(state, getters) {
    return getters.itemChoosen !== false ? getters.itemChoosen.description : false;
  },
  itemChoosenPrice: function itemChoosenPrice(state, getters) {
    return getters.itemChoosen !== false ? getters.itemChoosen.price : false;
  },
  itemChoosenPriceRef: function itemChoosenPriceRef(state, getters) {
    return getters.itemChoosen !== false ? getters.itemChoosen.priceRef : false;
  },
  dateChoosen: function dateChoosen(state) {
    return state.dateChoosen;
  },
  timeChoosen: function timeChoosen(state) {
    return state.timeChoosen;
  },
  unity: function unity(state) {
    if (state.client === null) return false;
    return state.client.unity;
  },
  unityChoosen: function unityChoosen(state) {
    return state.unityChoosen;
  },
  acceptance: function acceptance(state) {
    return state.acceptance;
  },
  requestSentModal: function requestSentModal(state) {
    return state.requestSentModal;
  },
  loadingOrderRequest: function loadingOrderRequest(state) {
    return state.loadingOrderRequest;
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(238);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    item: null,
    client: null,
    avaliableSchedule: [],
    loadingCheckout: false,
    timeChoosen: null,
    dateChoosen: null,
    hotSiteToken: null,
    unityChoosen: null,
    acceptance: false,
    loadingOrderRequest: false,
    itemChoosen: '',
    paymentChoosen: '',
    cart: {
      user: {
        id: ''
      },
      item: [{
        id: '',
        count: 1,
        questions: {}
      }]
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setHotSiteToken: function setHotSiteToken(state, payload) {
    state.hotSiteToken = payload;
  },
  loadAvaliableSchedule: function loadAvaliableSchedule(state, payload) {
    state.avaliableSchedule = payload;
  },
  loadItem: function loadItem(state, payload) {
    state.item = payload;
    state.item.priceTable = payload.itemFornecedor.priceTable;
    state.item.paymentsViewModel = payload.itemFornecedor.paymentsViewModel;
    if (payload.itemFornecedor.priceTable && payload.itemFornecedor.priceTable.length > 0) {
      state.itemChoosen = payload.itemFornecedor.priceTable[0].provider;
    }
    state.dateChoosen = state.item.dates[0];
  },
  loadClient: function loadClient(state, payload) {
    state.client = payload;
  },
  toggleLoadingCheckout: function toggleLoadingCheckout(state, value) {
    state.loadingCheckout = value;
  },
  updateTimeChoosen: function updateTimeChoosen(state, value) {
    state.timeChoosen = value;
  },
  updateDateChoosen: function updateDateChoosen(state, value) {
    state.dateChoosen = value;
  },
  updatePaymentChoosen: function updatePaymentChoosen(state, value) {
    state.paymentChoosen = value;
  },
  updateItemChoosen: function updateItemChoosen(state, value) {
    state.itemChoosen = value;
  },
  updateUnityChoosen: function updateUnityChoosen(state, value) {
    state.unityChoosen = value;
  },
  updateAcceptance: function updateAcceptance(state, value) {
    state.acceptance = value;
  },
  toggleRequestSentModal: function toggleRequestSentModal(state, value) {
    state.requestSentModal = value;
  },
  toggleLoadingOrderRequest: function toggleLoadingOrderRequest(state, value) {
    state.loadingOrderRequest = value;
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


// import ordersList from './ordersList.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  getReasons: function getReasons(_ref) {
    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Agendamento/CancelReasons',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('loadReasons', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toastrAxiosError', error);
      });
    });
  },
  alterSchedule: function alterSchedule(_ref2, id) {
    var state = _ref2.state,
        commit = _ref2.commit,
        rootGetters = _ref2.rootGetters;

    // BUG: possivelmente o cancela está com erro
    commit('updateReason', id);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var schedule = state.selectedSchedule;
      schedule.idReason = id;
      commit('toggleAlteredScheduleSaving', true);
      commit('toggleScheduleEditing');
      commit('toggleLoadingCanceled');
      commit('toggleAlterDateModal', false);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Agendamento/AlterSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: schedule
      }).then(function (response) {
        commit('selectSchedule', response.data.resultado);
        commit('updateRegisteredSchedules', response.data.resultado);
        commit('toastr', {
          color: 'success',
          texto: 'Dados alterados com sucesso'
        });
        commit('toggleLoadingCanceled', false);
        commit('toggleAlteredScheduleSaving', false);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toastrAxiosError', error);
        commit('toggleLoadingCanceled', false);
        commit('toggleAlteredScheduleSaving', false);
      });
    });
  },
  sendEmail: function sendEmail(_ref3) {
    var state = _ref3.state,
        commit = _ref3.commit,
        rootGetters = _ref3.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingCanceled', true);
      commit('toggleSendEmailModal', false);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Agendamento/SendEmails',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: state.selectedSchedule
      }).then(function (response) {
        commit('selectSchedule', response.data.resultado);
        commit('updateRegisteredSchedules', response.data.resultado);
        commit('toastr', {
          color: 'success',
          texto: 'E-mails encaminhados'
        });
        commit('toggleLoadingCanceled', false);
        commit('toggleScheduleDetailsModal', false);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toastrAxiosError', error);
        commit('toggleLoadingCanceled', false);
      });
    });
  },
  showOrders: function showOrders(_ref4, id) {
    var state = _ref4.state,
        commit = _ref4.commit,
        rootGetters = _ref4.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/BySchedule?id=' + id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadScheduleOrders', response.data.resultado);
        commit('toggleScheduleOrdersModal', true);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  cancelSchedule: function cancelSchedule(_ref5) {
    var state = _ref5.state,
        commit = _ref5.commit,
        rootGetters = _ref5.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingCanceled', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Agendamento/CancelSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: state.selectedSchedule
      }).then(function (response) {
        commit('updateRegisteredSchedules', response.data.resultado);
        commit('toastr', {
          color: 'success',
          texto: 'Agendamento cancelado com sucesso'
        });
        commit('toggleLoadingCanceled', false);
        commit('toggleScheduleDetailsModal', false);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toastrAxiosError', error);
        commit('toggleLoadingCanceled', false);
      });
    });
  },
  finishSchedule: function finishSchedule(_ref6) {
    var state = _ref6.state,
        commit = _ref6.commit,
        rootGetters = _ref6.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingFinished', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Agendamento/FinishSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: state.selectedSchedule
      }).then(function (response) {
        commit('updateRegisteredSchedules', response.data.resultado);
        commit('toggleLoadingFinished', false);
        commit('toggleScheduleDetailsModal', false);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toastrAxiosError', error);
        commit('toggleLoadingFinished', false);
      });
    });
  },
  saveSchedule: function saveSchedule(_ref7) {
    var state = _ref7.state,
        commit = _ref7.commit,
        rootGetters = _ref7.rootGetters,
        dispatch = _ref7.dispatch;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    commit('toggleLoadingSaved', true);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // BUG: alterar todos os date para dates ajustado?
      // let a = state.selectedSchedule
      // a.dates = a.date
      // a.date = null
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Agendamento/SaveSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: state.selectedSchedule
      }).then(function (response) {
        commit('appendNewSchedule', response.data.resultado);
        commit('selectSchedule', response.data.resultado);
        commit('toggleScheduleDetailsModal', false);
        commit('toggleLoadingSaved', false);
        commit('toastr', {
          color: 'success',
          texto: 'Agendamento realizado com sucesso'
        });
        if (payload && response.data.resultado.id) {
          dispatch('selectSchedule', response.data.resultado.id);
        }
        // commit('toggleScheduleDetailsModal', true)
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description,
              time: 5000
            });
          }
        }
        commit('toastrAxiosError', error);
        commit('toggleLoadingSaved', false);
      });
    });
  },
  searchCondominiumCnpj: function searchCondominiumCnpj(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit,
        rootGetters = _ref8.rootGetters;

    // BUG: parametros fixos, por causa do back end
    if (state.searchCnpj.length !== 14) {
      return;
    }
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingCondominium', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Agendamento/SearchDoc?cnpj=' + state.searchCnpj + '&param=P_PARCERIAJUPITER&conteudo=S',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        if (response.data.resultado.condominium !== null) {
          commit('loadCondominium', response.data.resultado.condominium);
        } else {
          commit('errorSearchCnpj', true);
        }
        commit('toggleLoadingCondominium', false);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingCondominium', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  newScheduleSelectedItem: function newScheduleSelectedItem(_ref9, payload) {
    var commit = _ref9.commit;

    commit('toggleScheduleDetailsModal', true);
    commit('selectScheduleItem', payload);
  },
  selectSchedule: function selectSchedule(_ref10, scheduleId) {
    var state = _ref10.state,
        commit = _ref10.commit,
        rootGetters = _ref10.rootGetters;

    if (scheduleId === '') {
      commit('toggleScheduleDetailsModal', true);
    } else {
      commit('toggleLoadingMounted', true);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default()({
          method: 'get',
          url: "/api/v1/" + 'Agendamento/DetailSchedule?schedule=' + scheduleId,
          timeout: 200000,
          headers: {
            'Token': rootGetters.token
          }
        }).then(function (response) {
          commit('toggleLoadingMounted', false);
          commit('selectSchedule', response.data.resultado);
          commit('toggleScheduleDetailsModal', true);
        }).catch(function (error) {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros;
            var description = '';
            if (erros.length > 0) {
              erros.forEach(function (element) {
                description = description + ' ' + element;
              });
            } else {
              description = erros[0];
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              });
            }
          }
          commit('toggleLoadingMounted', false);
          commit('toastrAxiosError', error);
        });
      });
    }
  },

  // gets
  getScheduledSchedule: function getScheduledSchedule(_ref11, id) {
    var state = _ref11.state,
        commit = _ref11.commit,
        rootGetters = _ref11.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Agendamento/Scheduled',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadSchedules', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getAwaitSchedule: function getAwaitSchedule(_ref12, id) {
    var state = _ref12.state,
        commit = _ref12.commit,
        rootGetters = _ref12.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Agendamento/AwaitSchedules',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadSchedules', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getFinishedSchedule: function getFinishedSchedule(_ref13, id) {
    var state = _ref13.state,
        commit = _ref13.commit,
        rootGetters = _ref13.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Agendamento/AllFinishedSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadSchedules', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getCanceledSchedule: function getCanceledSchedule(_ref14, id) {
    var state = _ref14.state,
        commit = _ref14.commit,
        rootGetters = _ref14.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Agendamento/AllCanceledSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadSchedules', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  addOrRemoveItemSchedule: function addOrRemoveItemSchedule(_ref15, payload) {
    var state = _ref15.state,
        commit = _ref15.commit,
        rootGetters = _ref15.rootGetters;

    var itens = state.selectedItens.filter(function (elem) {
      return elem.id === payload.id;
    });

    if (itens.length > 0) {
      commit('removeItemForScheduled', payload);
    } else {
      commit('addItemForScheduled', payload);
    }
    // if (state.selectedItens.indexOf(payload) === -1) {
    // } else {
    // }
  },
  setErrorDisponibilityInterval: function setErrorDisponibilityInterval(_ref16, payload) {
    var state = _ref16.state,
        commit = _ref16.commit,
        rootGetters = _ref16.rootGetters;

    if (payload) {
      commit('toastr', {
        color: 'error',
        texto: 'Intervalo não selecionado'
      });
    }
    state.errorDisponibilityInterval = payload;
  }
  // getAllScheduled ({state, commit, rootGetters}, id) {
  //   return new Promise((resolve, reject) => {
  //     commit('toggleLoadingMounted', true)
  //     axios({
  //       method: 'get',
  //       url: process.url + 'Agendamento/AllScheduled',
  //       timeout: 200000,
  //       headers: {
  //         'Token': rootGetters.token
  //       }
  //     })
  //     .then((response) => {
  //       commit('toggleLoadingMounted', false)
  //       commit('loadSchedules', response.data.resultado)
  //     })
  //     .catch((error) => {
  //       commit('toggleLoadingMounted', false)
  //       commit('toastrAxiosError', error)
  //     })
  //   })
  // }

});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  scheduledSchedule: function scheduledSchedule(state) {
    return state.registeredSchedules.filter(function (elem) {
      return elem.status === 0;
    });
  },
  awaitSchedule: function awaitSchedule(state) {
    return state.registeredSchedules.filter(function (elem) {
      return elem.status === 5;
    });
  },
  finishedSchedule: function finishedSchedule(state) {
    return state.registeredSchedules.filter(function (elem) {
      return elem.status === 2;
    });
  },
  canceledSchedule: function canceledSchedule(state) {
    return state.registeredSchedules.filter(function (elem) {
      return elem.status === 1;
    });
  },

  // allRegisteredSchedules (state) {
  //   return state.registeredSchedules.sort(function (a, b) {
  //     return b.controlNumber - a.controlNumber
  //   })
  // },
  searchSchedule: function searchSchedule(state) {
    return state.searchSchedule;
  },
  scheduleEditing: function scheduleEditing(state) {
    return state.scheduleEditing;
  },
  reasons: function reasons(state) {
    return state.reasons;
  },
  sendEmailModal: function sendEmailModal(state) {
    return state.sendEmailModal;
  },
  selectedSchedule: function selectedSchedule(state) {
    return state.selectedSchedule;
  },
  registeredScheduleOrders: function registeredScheduleOrders(state) {
    return state.registeredScheduleOrders;
  },
  alterDateModal: function alterDateModal(state) {
    return state.alterDateModal;
  },
  scheduleOrdersModal: function scheduleOrdersModal(state) {
    return state.scheduleOrdersModal;
  },
  scheduleDetailsModal: function scheduleDetailsModal(state) {
    return state.scheduleDetailsModal;
  },
  timeScheduleModal: function timeScheduleModal(state) {
    return state.timeScheduleModal;
  },
  loadingCondominium: function loadingCondominium(state) {
    return state.loadingCondominium;
  },
  searchCnpj: function searchCnpj(state) {
    return state.searchCnpj;
  },
  errorSearchCnpj: function errorSearchCnpj(state) {
    return state.errorSearchCnpj;
  },
  loadingScheduleActions: function loadingScheduleActions(state) {
    return state.loadingSaved || state.loadingCanceled || state.loadingFinished;
  },
  disponibility: function disponibility(state) {
    return state.selectedSchedule.disponibility;
  },
  disponibilityStart: function disponibilityStart(state) {
    return state.selectedSchedule.disponibility.start;
  },
  disponibilityEnd: function disponibilityEnd(state) {
    return state.selectedSchedule.disponibility.end;
  },
  disponibilityInterval: function disponibilityInterval(state) {
    return state.selectedSchedule.disponibility.interval;
  },
  alteredScheduleSaving: function alteredScheduleSaving(state) {
    return state.alteredScheduleSaving;
  },
  alteredSchedule: function alteredSchedule(state) {
    var idSelectedItens = state.selectedItens.map(function (elem) {
      return elem.id;
    });
    var idAlteredState = state.alteredSchedule.itens.map(function (elem) {
      return elem.id;
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.selectedSchedule) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.alteredSchedule) || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(idSelectedItens) !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(idAlteredState);
  },
  alteredScheduleDateWarning: function alteredScheduleDateWarning(state) {
    if (state.selectedSchedule.id === '') {
      return false;
    }
    return state.selectedSchedule.dates.length > 0 ? state.selectedSchedule.dates !== state.alteredSchedule.dates && state.selectedSchedule.sent : false;
  },
  scheduleDone: function scheduleDone(state) {
    return state.selectedSchedule.status > 0;
  },
  dateConfigModal: function dateConfigModal(state) {
    return state.dateConfigModal;
  },
  selectedScheduleIdChanged: function selectedScheduleIdChanged(state) {
    return state.selectedSchedule.id;
  },
  selectedItens: function selectedItens(state) {
    return state.selectedItens;
  },
  selectedScheduleHasItens: function selectedScheduleHasItens(state) {
    return typeof state.selectedSchedule.itens === 'undefined' || state.selectedSchedule.itens.length === 0;
  },
  errorDisponibilityInterval: function errorDisponibilityInterval(state) {
    return state.errorDisponibilityInterval;
  },
  selectedScheduleCategory: function selectedScheduleCategory(state) {
    return state.selectedSchedule.category;
  },
  hasCategorySelectedAndSelectedItens: function hasCategorySelectedAndSelectedItens(state) {
    return state.selectedSchedule.category === '' || state.selectedItens.length === 0;
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(243);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    registeredSchedules: [],
    registeredScheduleOrders: [],
    scheduleOrdersModal: false,
    scheduleDetailsModal: false,
    sendEmailModal: false,
    alterDateModal: false,
    dateConfigModal: false,
    timeScheduleModal: false,
    searchCnpj: '',
    scheduleEditing: false,
    errorSearchCnpj: false,
    errorDisponibilityInterval: false,
    selectedItens: [],
    selectedSchedule: {
      id: '',
      category: '',
      itens: [],
      dates: [],
      status: 0,
      sent: false,
      condominium: {
        id: '',
        cnpj: '',
        name: '',
        address: '',
        addressNumber: '',
        neighborhood: '',
        city: '',
        state: '',
        zipCode: '',
        administrator: ''
      },
      disponibility: {
        capacity: 1,
        interval: null,
        start: null,
        end: null
      },
      code: ''
    },
    alteredSchedule: null,
    loadingCondominium: false,
    loadingSaved: false,
    loadingCanceled: false,
    loadingFinished: false,
    alteredScheduleSaving: false,
    reasons: [],
    searchSchedule: ''
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


// import debug from 'util'
/* harmony default export */ __webpack_exports__["a"] = ({
  loadReasons: function loadReasons(state, value) {
    state.reasons = value;
  },
  loadScheduleOrders: function loadScheduleOrders(state, value) {
    state.registeredScheduleOrders = value;
  },
  toggleAlterDateModal: function toggleAlterDateModal(state, value) {
    state.alterDateModal = value;
  },
  toggleScheduleOrdersModal: function toggleScheduleOrdersModal(state, value) {
    state.scheduleOrdersModal = value;
  },
  toggleSendEmailModal: function toggleSendEmailModal(state, value) {
    state.sendEmailModal = value;
  },
  toggleDateConfigModal: function toggleDateConfigModal(state, value) {
    state.dateConfigModal = value;
  },
  toggleScheduleDetailsModal: function toggleScheduleDetailsModal(state, value) {
    state.scheduleEditing = false;
    state.scheduleDetailsModal = value;
    if (!value) {
      state.selectedSchedule = {
        item: null,
        id: '',
        dates: [],
        status: 0,
        sent: false,
        condominium: {
          id: '',
          cnpj: '',
          name: '',
          address: '',
          addressNumber: '',
          neighborhood: '',
          city: '',
          state: '',
          zipCode: '',
          administrator: ''
        },
        disponibility: {
          capacity: 1,
          interval: null,
          start: null,
          end: null
        },
        code: ''
      };
    }
  },
  toggleTimeScheduleModal: function toggleTimeScheduleModal(state, value) {
    if (state.selectedSchedule.disponibility === null) {
      state.selectedSchedule.disponibility = {
        capacity: 1,
        interval: null,
        start: null,
        end: null
      };
    }
    state.timeScheduleModal = value;
  },
  updateReason: function updateReason(state, value) {
    state.selectedSchedule.idReason = value;
  },
  toggleLoadingCanceled: function toggleLoadingCanceled(state, value) {
    state.loadingCanceled = value;
  },
  toggleLoadingFinished: function toggleLoadingFinished(state, value) {
    state.loadingFinished = value;
  },
  toggleLoadingSaved: function toggleLoadingSaved(state, value) {
    state.loadingSaved = value;
  },
  toggleAlteredScheduleSaving: function toggleAlteredScheduleSaving(state, value) {
    state.alteredScheduleSaving = value;
  },
  selectScheduleItem: function selectScheduleItem(state, payload) {
    if (JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.selectedSchedule.item)) !== JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload))) {
      state.selectedSchedule = {
        // item: payload,
        id: '',
        dates: [],
        status: 0,
        sent: false,
        condominium: {
          id: '',
          cnpj: '',
          name: '',
          address: '',
          addressNumber: '',
          neighborhood: '',
          city: '',
          state: '',
          zipCode: '',
          administrator: ''
        },
        disponibility: {
          capacity: 1,
          interval: null,
          start: null,
          end: null
        },
        code: ''
      };
    } else {
      state.searchCnpj = '';
      state.selectedSchedule.item = null;
    }
  },
  selectScheduleItens: function selectScheduleItens(state, payload) {
    var _category = state.selectedSchedule.category;
    if (typeof state.selectedSchedule.itens === 'undefined' || JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.selectedSchedule.itens)) !== JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload))) {
      state.selectedSchedule = {
        itens: payload,
        id: '',
        category: _category,
        dates: [],
        status: 0,
        sent: false,
        condominium: {
          id: '',
          cnpj: '',
          name: '',
          address: '',
          addressNumber: '',
          neighborhood: '',
          city: '',
          state: '',
          zipCode: '',
          administrator: ''
        },
        disponibility: {
          capacity: 1,
          interval: null,
          start: null,
          end: null
        },
        code: ''
      };
    } else {
      state.searchCnpj = '';
      state.selectedSchedule.itens = [];
    }
  },
  newSearchCondominiumCnpj: function newSearchCondominiumCnpj(state, value) {
    state.searchCnpj = '';
    state.selectedSchedule.condominium = {
      id: '',
      cnpj: '',
      name: '',
      address: '',
      addressNumber: '',
      neighborhood: '',
      city: '',
      state: '',
      zipCode: '',
      administrator: ''
    };
  },
  newSchedule: function newSchedule(state, value) {
    state.selectedItens = [];
    state.scheduleDetailsModal = true;
    state.errorDisponibilityInterval = false;
    state.searchCnpj = '';
    state.selectedSchedule = {
      id: '',
      category: '',
      itens: value || [],
      dates: [],
      status: 0,
      sent: false,
      condominium: {
        id: '',
        cnpj: '',
        name: '',
        address: '',
        addressNumber: '',
        neighborhood: '',
        city: '',
        state: '',
        zipCode: '',
        administrator: ''
      },
      disponibility: {
        capacity: 1,
        interval: null,
        start: null,
        end: null
      },
      code: ''
    };
  },
  errorSearchCnpj: function errorSearchCnpj(state, value) {
    state.errorSearchCnpj = value;
  },
  appendNewSchedule: function appendNewSchedule(state, payload) {
    state.registeredSchedules.unshift(payload);
  },
  updateRegisteredSchedules: function updateRegisteredSchedules(state, payload) {
    if (payload !== true) {
      state.registeredSchedules = state.registeredSchedules.map(function (elem) {
        return elem.id === payload.id ? payload : elem;
      });
    }
  },
  updateScheduleCode: function updateScheduleCode(state, value) {
    state.selectedSchedule.code = value;
  },
  updateScheduleDate: function updateScheduleDate(state, value) {
    if (!value) {
      value = [];
    }
    state.selectedSchedule.dates = value;
  },
  toggleLoadingCondominium: function toggleLoadingCondominium(state, value) {
    state.loadingCondominium = value;
  },
  loadCondominium: function loadCondominium(state, payload) {
    state.selectedSchedule.condominium = payload;
  },
  loadSchedules: function loadSchedules(state, payload) {
    state.registeredSchedules = [].concat(state.registeredSchedules, payload);
  },
  selectSchedule: function selectSchedule(state, payload) {
    state.selectedSchedule = payload;
    // deep clone comparação
    state.alteredSchedule = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload));
  },
  toggleScheduleEditing: function toggleScheduleEditing(state) {
    state.scheduleEditing = !state.scheduleEditing;
    // deep clone
    state.selectedSchedule = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.alteredSchedule));
  },
  cancelChange: function cancelChange(state) {
    // deep clone
    state.selectedSchedule = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.alteredSchedule));
  },
  updateSearchCnpj: function updateSearchCnpj(state, value) {
    state.searchCnpj = value;
  },
  updateCapacity: function updateCapacity(state, value) {
    state.selectedSchedule.disponibility.capacity = value;
  },
  updateInterval: function updateInterval(state, value) {
    if (value) {
      state.errorDisponibilityInterval = false;
    }
    state.selectedSchedule.disponibility.interval = value;
  },
  updateDisponibilityStart: function updateDisponibilityStart(state, value) {
    if (__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(value).asHours() > __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(state.selectedSchedule.disponibility.end).asHours()) {
      state.selectedSchedule.disponibility.start = value;
      state.selectedSchedule.disponibility.end = null;
    } else {
      state.selectedSchedule.disponibility.start = value;
    }
  },
  updateDisponibilityEnd: function updateDisponibilityEnd(state, value) {
    state.selectedSchedule.disponibility.end = value;
  },
  updateSearchSchedule: function updateSearchSchedule(state, value) {
    state.searchSchedule = value;
  },
  resetAgendamento: function resetAgendamento(state) {
    state.registeredSchedules = [];
  },
  resetItemForScheduled: function resetItemForScheduled(state) {
    state.selectedItens = [];
  },
  addItemForScheduled: function addItemForScheduled(state, payload) {
    state.selectedItens.push(payload);
  },
  removeItemForScheduled: function removeItemForScheduled(state, payload) {
    state.selectedItens = state.selectedItens.filter(function (item) {
      return item.id !== payload.id;
    });
  },
  removeScheduleItem: function removeScheduleItem(state, payload) {
    state.selectedSchedule.itens = state.selectedSchedule.itens.filter(function (item) {
      return item.id !== payload.id;
    });
    if (state.selectedSchedule.itens.length === 0) {
      state.selectedItens = [];
      state.selectedSchedule.category = '';
    }
  },
  setSelectedScheduleCategory: function setSelectedScheduleCategory(state, payload) {
    state.selectedSchedule.category = payload;
  },
  setSelectScheduleItens: function setSelectScheduleItens(state, payload) {
    state.selectedSchedule.itens = payload;
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var queryString = __webpack_require__(345);
/* harmony default export */ __webpack_exports__["a"] = ({
  autenticar: function autenticar(_ref, payload) {
    var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('loadingAutenticacao', true);
      window.http.post('Autentica/Login', queryString.stringify(payload)).then(function (response) {
        commit('loadingAutenticacao', false);
        var data = response.data.resultado;
        if (data.code === 200) {
          // store TOKEN
          var auth = {
            nome: data.nome,
            nivel: data.nivel,
            token: data.token,
            status: data.status
          };
          commit('singIn', auth);
          if (!payload.mantemConectado) {
            auth.time = 1000 * 60 * 10;
            dispatch('singOut', auth.time);
            commit('createSession', auth);
          } else {
            auth.time = false;
            commit('createSession', auth);
          }
          resolve();
        } else {
          if (data.code === 302) {
            commit('toastr', {
              color: 'error',
              texto: 'Usuário inválido'
            });
          } else if (data.code === 303) {
            commit('toastr', {
              color: 'error',
              texto: 'Senha inválida'
            });
          } else if (data.code === 304) {
            commit('toastr', {
              color: 'error',
              texto: 'E-mail não confirmado'
            });
          } else if (data.code === 501) {
            commit('toastr', {
              color: 'error',
              texto: 'Erro interno'
            });
          }
          reject(data.code);
        }
      }).catch(function (error) {
        commit('loadingAutenticacao', false);
        commit('toastr', {
          color: 'error',
          texto: 'Erro de conexão'
        });
        reject(error);
      });
    });
  },
  logOut: function logOut(_ref2) {
    var commit = _ref2.commit,
        rootGetters = _ref2.rootGetters;

    commit('resetAgendamento');
    commit('resetEmpresa');
    commit('resetItem');
    commit('resetCategorie');
    commit('resetPedido');
    commit('singOut');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Autentica/Logout',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        resolve();
      });
    });
  },
  singOut: function singOut(_ref3, time) {
    var commit = _ref3.commit;

    setTimeout(function () {
      commit('singOut');
      window.location = '/Expirado';
    }, time);
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  registrationCompleted: function registrationCompleted(state) {
    return state.autenticacao.status === 0 || state.autenticacao.status === 4;
  },
  registrationStatusMessage: function registrationStatusMessage(state) {
    switch (state.autenticacao.status) {
      case 0:
        return 'você completou 100% do seu cadastro.';
      case 1:
        return 'você ainda não confirmou seu email!';
      case 2:
        return 'Ainda faltam algumas informações do seu cadastro, isso impacta diretamente nas suas vendas.';
      case 3:
        return 'estamos analizando as informações, aguarde a sua homologação 90% realizado.';
      case 4:
        return 'primeiro acesso você completou somente 100% do seu cadastro, boas vendas.';
    }
  },
  autenticacao: function autenticacao(state) {
    return state.autenticacao.autenticado;
  },
  token: function token(state) {
    return state.autenticacao.token;
  },
  nome: function nome(state) {
    return state.autenticacao.nome;
  },
  statusCode: function statusCode(state) {
    return state.autenticacao.status;
  },
  status: function status(state) {
    switch (state.autenticacao.status) {
      case 0:
        // homologado 100%
        return 100;
      case 1:
        // não confirmou o email
        return 0;
      case 2:
        // falta completar o cadastro
        return 60;
      case 3:
        // fez update do cadastro porem está esperando homologação
        return 90;
      case 4:
        // primeiro acesso apos ser homologado já foi homologado
        return 100;
    }
  },
  usuario: function usuario(state) {
    return state.usuario;
  },
  loadingAutenticacao: function loadingAutenticacao(state) {
    return state.loading;
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(247);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    autenticacao: {
      autenticado: false,
      nivel: 0,
      token: '',
      nome: '',
      status: 0
    },
    usuario: {
      login: '',
      senha: '',
      persistencia: true
    },
    loading: false
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var moment = __webpack_require__(0);
/* harmony default export */ __webpack_exports__["a"] = ({
  singOut: function singOut(state) {
    state.autenticacao.autenticado = false;
    document.cookie = 'tokenValidade=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    document.cookie = 'tokenAcesso=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    document.cookie = 'tokenNivel=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    document.cookie = 'tokenNome=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    document.cookie = 'tokenStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
  },
  singIn: function singIn(state, payload) {
    state.usuario.login = '';
    state.usuario.senha = '';
    state.autenticacao.autenticado = true;
    state.autenticacao.status = parseInt(payload.status);
    state.autenticacao.nivel = parseInt(payload.nivel);
    state.autenticacao.token = payload.token;
    state.autenticacao.nome = payload.nome;
    window.axios(state.autenticacao.token);
  },
  createSession: function createSession(state, payload) {
    var d = void 0;
    if (payload.time === false) {
      d = moment().add(1, 'y');
    } else {
      d = moment().add(payload.time, 'm');
    }
    var expires = d.format();
    // d.setTime(d.getTime() + 1000 * 60 * 1000)
    document.cookie = 'tokenValidade=' + expires + ';expires=' + expires + '; path=/';
    document.cookie = 'tokenAcesso=' + payload.token + ';expires=' + expires + '; path=/';
    document.cookie = 'tokenNivel=' + payload.nivel + ';expires=' + expires + '; path=/';
    document.cookie = 'tokenNome=' + payload.nome + ';expires=' + expires + '; path=/';
    document.cookie = 'tokenStatus=' + payload.status + ';expires=' + expires + '; path=/';
  },
  updatePersistencia: function updatePersistencia(state, value) {
    state.usuario.persistencia = value;
  },
  updateLogin: function updateLogin(state, value) {
    state.usuario.login = value;
  },
  updateSenha: function updateSenha(state, value) {
    state.usuario.senha = value;
  },
  loadingAutenticacao: function loadingAutenticacao(state, value) {
    state.loading = value;
  },
  updateStatus: function updateStatus(state, value) {
    state.autenticacao.status = value;
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  arrayCategorias: function arrayCategorias(state) {
    return state.categoriaSelecionadas;
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(251);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    categoriaSelecionadas: []
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  selecionaCategoria: function selecionaCategoria(state, payload) {
    state.categoriaSelecionadas = payload.valor;
  },
  removeCategoria: function removeCategoria(state, payload) {
    state.categoriaSelecionadas.splice(state.categoriaSelecionadas.indexOf(payload.valor), 1);
    state.categoriaSelecionadas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.categoriaSelecionadas));
  },
  resetarCategorias: function resetarCategorias(state) {
    state.categoriaSelecionadas = [];
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  sendEmail: function sendEmail(_ref, token) {
    var state = _ref.state,
        commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingEmail', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Hotsite/DontHaveAccess',
        timeout: 200000,
        headers: {
          'Token': token
        },
        data: state
      }).then(function (response) {
        commit('toggleLoadingEmail', false);
        resolve(true);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingEmail', false);
        commit('toastrAxiosError', error, { root: true });
      });
    });
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: function state(_state) {
    return _state;
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(254);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    name: '',
    document: '',
    phone: '',
    email: '',
    loading: false
  },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  updateName: function updateName(state, value) {
    state.name = value;
  },
  updateDocument: function updateDocument(state, value) {
    state.document = value;
  },
  updatePhone: function updatePhone(state, value) {
    state.phone = value;
  },
  updateEmail: function updateEmail(state, value) {
    state.email = value;
  },
  toggleLoadingEmail: function toggleLoadingEmail(state, value) {
    state.loadingEmail = value;
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  loadCategories: function loadCategories(_ref) {
    var state = _ref.state,
        commit = _ref.commit;

    if (state.categories.length === 0) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        window.http.get('Categoria/GetCategoriasByFornecedor').then(function (response) {
          commit('loadCategories', response.data.resultado);
        }).catch(function (error) {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros;
            var description = '';
            if (erros.length > 0) {
              erros.forEach(function (element) {
                description = description + ' ' + element;
              });
            } else {
              description = erros[0];
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              });
            }
          }
          commit('toastrAxiosError', error);
        });
      });
    }
  },
  loadAllowedCategories: function loadAllowedCategories(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit;

    if (state.categories.length === 0) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        window.http.get('Categoria/GetCategoriasByFornecedorForScheduled').then(function (response) {
          commit('loadAllowedCategories', response.data.resultado);
        }).catch(function (error) {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros;
            var description = '';
            if (erros.length > 0) {
              erros.forEach(function (element) {
                description = description + ' ' + element;
              });
            } else {
              description = erros[0];
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              });
            }
          }
          commit('toastrAxiosError', error);
        });
      });
    }
  },
  loadPayments: function loadPayments(_ref3) {
    var state = _ref3.state,
        commit = _ref3.commit;

    if (state.categories.length === 0) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        window.http.get('Pagamento/GetPayments').then(function (response) {
          commit('loadPayments', response.data.resultado);
        }).catch(function (error) {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros;
            var description = '';
            if (erros.length > 0) {
              erros.forEach(function (element) {
                description = description + ' ' + element;
              });
            } else {
              description = erros[0];
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              });
            }
          }
          commit('toastrAxiosError', error);
        });
      });
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  categories: function categories(state) {
    return state.categories;
  },
  allowedCategoriesForScheduled: function allowedCategoriesForScheduled(state) {
    return state.allowedCategoriesForScheduled;
  },
  payments: function payments(state) {
    return state.payments;
  },
  families: function families(state) {
    return state.families;
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(259);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    endereco: '',
    nomeEmpresa: '',
    plano: '',
    statusCadastro: 60,
    categories: [],
    allowedCategoriesForScheduled: [],
    payments: [],
    families: []
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadCategories: function loadCategories(state, value) {
    state.categories = value;
  },
  loadAllowedCategories: function loadAllowedCategories(state, value) {
    state.allowedCategoriesForScheduled = value;
  },
  loadPayments: function loadPayments(state, value) {
    state.payments = value;
  },
  resetCategorie: function resetCategorie(state) {
    state.categories = [];
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



// const queryString = require('query-string')


/* harmony default export */ __webpack_exports__["a"] = ({
  updateCompany: function updateCompany(_ref) {
    var state = _ref.state,
        commit = _ref.commit,
        rootGetters = _ref.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var phone = state.company.phone.replace(/\D/g, '');
      state.company.zipCode = state.company.zipCode.replace(/\D/g, '');
      var areaCode = phone.substring(0, 2);
      var phoneNumber = phone.substring(2, phone.length);
      var form = new FormData();
      form.append('fantasia', state.company.tradingName);
      form.append('DDD', areaCode);
      form.append('Telefone', phoneNumber);
      form.append('Categorias', state.company.categories);
      form.append('Endereco', state.company.address);
      form.append('Nro', state.company.addressNumber);
      form.append('Cep', state.company.zipCode);
      form.append('Bairro', state.company.neighborhood);
      form.append('Cidade', state.company.city);
      form.append('UF', state.company.state);
      // form.append('DocId', '')
      // form.append('Contato', '')
      form.append('Url', state.company.site);
      form.append('Complemento', state.company.complement);
      form.append('DescricaoNegocio', state.company.description);
      form.append('Logo', state.company.logo);

      form.append('NeedSchedule', state.company.needSchedule);
      form.append('CustomTime', state.company.customTime);

      form.append('WeekDayStart', state.company.weekDayStart);
      form.append('WeekDayEnd', state.company.weekDayEnd);
      form.append('WeekDayInterval', state.company.weekDayInterval);
      form.append('WeekDayCapacity', state.company.weekDayCapacity);

      form.append('SundayStart', state.company.sundayStart);
      form.append('SundayEnd', state.company.sundayEnd);
      form.append('SundayInterval', state.company.sundayInterval);
      form.append('SundayCapacity', state.company.sundayCapacity);

      form.append('MondayStart', state.company.mondayStart);
      form.append('MondayEnd', state.company.mondayEnd);
      form.append('MondayInterval', state.company.mondayInterval);
      form.append('MondayCapacity', state.company.mondayCapacity);

      form.append('TuesdayStart', state.company.tuesdayStart);
      form.append('TuesdayEnd', state.company.tuesdayEnd);
      form.append('TuesdayInterval', state.company.tuesdayInterval);
      form.append('TuesdayCapacity', state.company.tuesdayCapacity);

      form.append('WednesdayStart', state.company.wednesdayStart);
      form.append('WednesdayEnd', state.company.wednesdayEnd);
      form.append('WednesdayInterval', state.company.wednesdayInterval);
      form.append('WednesdayCapacity', state.company.wednesdayCapacity);

      form.append('ThursdayStart', state.company.thursdayStart);
      form.append('ThursdayEnd', state.company.thursdayEnd);
      form.append('ThursdayInterval', state.company.thursdayInterval);
      form.append('ThursdayCapacity', state.company.thursdayCapacity);

      form.append('FridayStart', state.company.fridayStart);
      form.append('FridayEnd', state.company.fridayEnd);
      form.append('FridayInterval', state.company.fridayInterval);
      form.append('FridayCapacity', state.company.fridayCapacity);

      form.append('SaturdayStart', state.company.saturdayStart);
      form.append('SaturdayEnd', state.company.saturdayEnd);
      form.append('SaturdayInterval', state.company.saturdayInterval);
      form.append('SaturdayCapacity', state.company.saturdayCapacity);

      commit('loadingCompany', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Cadastro/Salvar',
        timeout: 200000,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token': rootGetters.token
        },
        data: form
      }).then(function (response) {
        commit('loadingCompany', false);
        var data = response.data;
        if (data.preErros.length > 0) {
          commit('toastrApiError', data.preErros);
          reject(data);
          // TODO: Integrar a api com erros[]
        } else {
          commit('toastr', {
            color: 'success',
            texto: 'Dados alterados'
          });
          // clear input and load http logo
          if (data.resultado.logo !== '') {
            commit('updateLogo', data.resultado.logo);
          }
          commit('updateStatus', data.resultado.code);
          commit('unshelfLogo');
          // TODO: se status for 60% mandar uma mensagem de esperando omologação commit('homologaçõa')
          resolve();
        }
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('loadingCompany', false);
        commit('toastrAxiosError', error);
        // reject(error)
      });
    });
  },
  zipCodeSearch: function zipCodeSearch(_ref2, payload) {
    var state = _ref2.state,
        commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('loadingZipCode', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://viacep.com.br/ws/' + state.company.zipCode + '/json/').then(function (response) {
        commit('loadingZipCode', false);
        if (response.erro) {
          commit('toastr', {
            color: 'error',
            texto: 'CEP não encontrado'
          });
        } else {
          commit('updateAddress', response.data.logradouro);
          commit('updateNeighborhood', response.data.bairro);
          commit('updateState', response.data.uf);
          commit('updateCity', response.data.localidade);
        }
      }).catch(function (error) {
        console.log(error);
        commit('toastr', {
          color: 'error',
          texto: 'CEP não encontrado'
        });
        commit('loadingZipCode', false);
      });
    });
  },
  getCompanyData: function getCompanyData(_ref3) {
    var state = _ref3.state,
        commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      window.http.get('Fornecedor/GetDetalhe').then(function (response) {
        resolve();
        commit('loadCompany', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toastrAxiosError', error);
      });
    });
  },
  shelfLogo: function shelfLogo(_ref4, value) {
    var state = _ref4.state,
        commit = _ref4.commit;

    var reader = new FileReader();
    commit('updateLogo', value);
    reader.onload = function (e) {
      state.logoNotSent = e.target.result;
    };
    reader.readAsDataURL(value);
  },
  getEvaluations: function getEvaluations(_ref5) {
    var state = _ref5.state,
        commit = _ref5.commit,
        rootGetters = _ref5.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Fornecedor/Evaluations?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadEvaluations', response.data.resultado);
      }).catch(function (error) {
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getUsers: function getUsers(_ref6) {
    var state = _ref6.state,
        commit = _ref6.commit,
        rootGetters = _ref6.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Fornecedor/GetUsuarios?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadUsers', response.data.resultado);
      }).catch(function (error) {
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  selectUser: function selectUser(_ref7, id) {
    var state = _ref7.state,
        commit = _ref7.commit;

    if (id === 0) {
      commit('newUser');
      commit('toggleUserModal', true);
      return;
    } else {
      commit('toggleLoadingMounted', true);
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        window.http.get('Fornecedor/GetUsuario?id=' + id).then(function (response) {
          commit('toggleLoadingMounted', false);
          commit('selectUser', response.data.resultado);
          commit('toggleUserModal', true);
        }).catch(function (error) {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros;
            var description = '';
            if (erros.length > 0) {
              erros.forEach(function (element) {
                description = description + ' ' + element;
              });
            } else {
              description = erros[0];
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              });
            }
          }
          commit('toastrAxiosError', error);
        });
      });
    }
  },
  updateUser: function updateUser(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit,
        rootGetters = _ref8.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // window.http.post('Itens/Salvar', queryString.stringify(JSON.stringify(state.selectedItem)))
      var form = new FormData();
      for (var key in state.selectedUser) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(state.selectedUser[key]) === 'object') {
          form.append(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.selectedUser[key]));
        } else {
          form.append(key, state.selectedUser[key]);
        }
      }
      commit('toggleLoadingItemAction', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Fornecedor/SalvarUsuario',
        timeout: 200000,
        headers: { 'Token': rootGetters.token },
        data: form
      }).then(function (response) {
        commit('toggleLoadingItemAction', false);
        var data = response.data;
        if (data.preErros.length > 0) {
          // commit('toastrApiError', data.preErros)
          reject(data);
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          });
          // TODO: Integrar a api com erros[]
        } else {
          if (data.preErros.length > 0) {
            commit('toastr', {
              color: 'error',
              texto: data.preErros[0]
            });
          } else {
            if (state.selectedUser.id === 0) {
              commit('appendNewUser', data.resultado);
              commit('toggleUserModal', false);
              commit('toastr', {
                color: 'success',
                texto: 'Usuário cadastrado com sucesso'
              });
            } else {
              commit('updateRegisteredUsers', data.resultado);
              commit('toastr', {
                color: 'success',
                texto: 'Usuário atualizado com sucesso'
              });
              commit('toggleUserModal', false);
            }
          }
          resolve();
        }
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingItemAction', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  salvarResposta: function salvarResposta(_ref9) {
    var state = _ref9.state,
        commit = _ref9.commit,
        rootGetters = _ref9.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var form = new FormData();
      form.append('idNota', state.selectedAvaliacao.id);
      form.append('resposta', state.selectedAvaliacao.resposta);
      commit('toggleLoadingItemAction', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Fornecedor/SalvarRespostaAvaliacao',
        timeout: 200000,
        headers: { 'Token': rootGetters.token },
        data: form
      }).then(function (response) {
        commit('toggleLoadingItemAction', false);
        var data = response.data;
        if (data.preErros.length > 0) {
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          });
        } else {
          commit('appendNewItem', data.resultado);
          commit('toggleItemModal', false);
          commit('toastr', {
            color: 'success',
            texto: 'Resposta cadastrada com sucesso'
          });
        }
        resolve();
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingItemAction', false);
        commit('toastrAxiosError', error);
      });
    });
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* harmony default export */ __webpack_exports__["a"] = ({
  company: function company(state) {
    return state.company;
  },
  isImage: function isImage(state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(state.company.logo) === 'object' || state.company.logo === '';
  },
  loadingCompany: function loadingCompany(state) {
    return state.loadingCompany;
  },
  loadingZipCode: function loadingZipCode(state) {
    return state.loadingZipCode;
  },
  shelfedLogo: function shelfedLogo(state) {
    return state.logoNotSent;
  },
  waitingApproval: function waitingApproval(state) {
    return state.waitingApproval;
  },
  tradingName: function tradingName(state) {
    return state.company.tradingName;
  },
  currentPage: function currentPage(state) {
    return state.currentPage;
  },
  totalPages: function totalPages(state) {
    return state.totalPages;
  },
  totalItems: function totalItems(state) {
    return state.totalItems;
  },
  itemsPerPage: function itemsPerPage(state) {
    return state.itemsPerPage;
  },
  evaluations: function evaluations(state) {
    return state.evaluations;
  },
  users: function users(state) {
    return state.users;
  },
  userVisible: function userVisible(state) {
    return state.userModal;
  },
  selectedUser: function selectedUser(state) {
    return state.selectedUser;
  },
  selectedAvaliacao: function selectedAvaliacao(state) {
    return state.selectedAvaliacao;
  },
  evaluationVisible: function evaluationVisible(state) {
    return state.evaluationModal;
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(263);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    company: {
      logo: '',
      tradingName: '',
      document: '',
      phone: '',
      email: '',
      description: '',
      site: '',
      zipCode: '',
      address: '',
      addressNumber: '',
      complement: '',
      neighborhood: '',
      state: '',
      city: '',
      categories: '',
      needSchedule: false,
      customTime: false,
      weekDayStart: '',
      weekDayEnd: '',
      weekDayInterval: '',
      weekDayCapacity: 0,
      sundayStart: '',
      sundayEnd: '',
      sundayInterval: '',
      sundayCapacity: 0,
      mondayStart: '',
      mondayEnd: '',
      mondayInterval: '',
      mondayCapacity: 0,
      tuesdayStart: '',
      tuesdayEnd: '',
      tuesdayInterval: '',
      tuesdayCapacity: 0,
      wednesdayStart: '',
      wednesdayEnd: '',
      wednesdayInterval: '',
      wednesdayCapacity: 0,
      thursdayStart: '',
      thursdayEnd: '',
      thursdayInterval: '',
      thursdayCapacity: 0,
      fridayStart: '',
      fridayEnd: '',
      fridayInterval: '',
      fridayCapacity: 0,
      saturdayStart: '',
      saturdayEnd: '',
      saturdayInterval: '',
      saturdayCapacity: 0
    },
    logoNotSent: '',
    loadingCompany: false,
    loadingZipCode: false,
    waitingApproval: false,
    evaluations: [],
    users: [],
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    itemsPerPage: 12,
    paginaInicial: 0,
    paginaFinal: 0,
    userModal: false,
    evaluationModal: false,
    loadingEvaluationAction: false,
    loadingUserAction: false,
    selectedAvaliacao: {
      id: 0,
      data: '',
      usuario: '',
      item: '',
      nota: '',
      comentario: '',
      resposta: ''
    },
    selectedUser: {
      id: 0,
      nome: '',
      login: '',
      telefone: '',
      email: '',
      departamento: '',
      active: true,
      senha: ''
    }
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadCompany: function loadCompany(state, payload) {
    state.company = {
      tradingName: payload.fantasia,
      document: payload.documento,
      phone: payload.ddd + payload.telefone,
      email: payload.email,
      logo: payload.logo,
      description: payload.descricaoNegocio,
      site: payload.url,
      zipCode: payload.cep,
      address: payload.endereco,
      addressNumber: payload.nro,
      complement: payload.complemento,
      neighborhood: payload.bairro,
      state: payload.uf,
      city: payload.cidade,
      categories: payload.categorias,
      needSchedule: payload.needSchedule,
      customTime: payload.customTime,
      weekDayStart: payload.weekDayStart,
      weekDayEnd: payload.weekDayEnd,
      weekDayInterval: payload.weekDayInterval,
      weekDayCapacity: payload.weekDayCapacity,
      sundayStart: payload.sundayStart,
      sundayEnd: payload.sundayEnd,
      sundayInterval: payload.sundayInterval,
      sundayCapacity: payload.sundayCapacity,
      mondayStart: payload.mondayStart,
      mondayEnd: payload.mondayEnd,
      mondayInterval: payload.mondayInterval,
      mondayCapacity: payload.mondayCapacity,
      tuesdayStart: payload.tuesdayStart,
      tuesdayEnd: payload.tuesdayEnd,
      tuesdayInterval: payload.tuesdayInterval,
      tuesdayCapacity: payload.tuesdayCapacity,
      wednesdayStart: payload.wednesdayStart,
      wednesdayEnd: payload.wednesdayEnd,
      wednesdayInterval: payload.wednesdayInterval,
      wednesdayCapacity: payload.wednesdayCapacity,
      thursdayStart: payload.thursdayStart,
      thursdayEnd: payload.thursdayEnd,
      thursdayInterval: payload.thursdayInterval,
      thursdayCapacity: payload.thursdayCapacity,
      fridayStart: payload.fridayStart,
      fridayEnd: payload.fridayEnd,
      fridayInterval: payload.fridayInterval,
      fridayCapacity: payload.fridayCapacity,
      saturdayStart: payload.saturdayStart,
      saturdayEnd: payload.saturdayEnd,
      saturdayInterval: payload.saturdayInterval,
      saturdayCapacity: payload.saturdayCapacity
    };
  },
  unshelfLogo: function unshelfLogo(state, value) {
    state.logoNotSent = '';
  },
  updateLogo: function updateLogo(state, value) {
    state.company.logo = value;
  },
  updateTradingName: function updateTradingName(state, value) {
    state.company.tradingName = value;
  },
  updateDocument: function updateDocument(state, value) {
    state.company.document = value;
  },
  updatePhone: function updatePhone(state, value) {
    state.company.phone = value;
  },
  updateEmail: function updateEmail(state, value) {
    state.company.email = value;
  },
  updateDescription: function updateDescription(state, value) {
    state.company.description = value;
  },
  updateSite: function updateSite(state, value) {
    state.company.site = value;
  },
  updateZipCode: function updateZipCode(state, value) {
    state.company.zipCode = value;
  },
  updateAddress: function updateAddress(state, value) {
    state.company.address = value;
  },
  updateAddressNumber: function updateAddressNumber(state, value) {
    state.company.addressNumber = value;
  },
  updateComplement: function updateComplement(state, value) {
    state.company.complement = value;
  },
  updateNeighborhood: function updateNeighborhood(state, value) {
    state.company.neighborhood = value;
  },
  updateState: function updateState(state, value) {
    state.company.state = value;
  },
  updateCity: function updateCity(state, value) {
    state.company.city = value;
  },
  loadingCompany: function loadingCompany(state, value) {
    state.loadingCompany = value;
  },
  loadingZipCode: function loadingZipCode(state, value) {
    state.loadingZipCode = value;
  },
  toggleWaitingApproval: function toggleWaitingApproval(state, value) {
    state.waitingApproval = value;
  },
  resetEmpresa: function resetEmpresa(state) {
    state.company = {
      tradingName: '',
      document: '',
      phone: '',
      email: '',
      logo: '',
      description: '',
      site: '',
      zipCode: '',
      address: '',
      addressNumber: '',
      complement: '',
      neighborhood: '',
      state: '',
      city: '',
      categories: [],
      needSchedule: false,
      customTime: false,
      weekDayStart: '',
      weekDayEnd: '',
      weekDayInterval: '',
      weekDayCapacity: 0,
      sundayStart: '',
      sundayEnd: '',
      sundayInterval: '',
      sundayCapacity: 0,
      mondayStart: '',
      mondayEnd: '',
      mondayInterval: '',
      mondayCapacity: 0,
      tuesdayStart: '',
      tuesdayEnd: '',
      tuesdayInterval: '',
      tuesdayCapacity: 0,
      wednesdayStart: '',
      wednesdayEnd: '',
      wednesdayInterval: '',
      wednesdayCapacity: 0,
      thursdayStart: '',
      thursdayEnd: '',
      thursdayInterval: '',
      thursdayCapacity: 0,
      fridayStart: '',
      fridayEnd: '',
      fridayInterval: '',
      fridayCapacity: 0,
      saturdayStart: '',
      saturdayEnd: '',
      saturdayInterval: '',
      saturdayCapacity: 0
    };
  },
  loadEvaluations: function loadEvaluations(state, payload) {
    state.totalItems = payload.totalItens;
    state.currentPage = payload.paginaAtual;
    state.totalPages = payload.totalPaginas;
    state.itemsPerPage = payload.itensPorPagina;
    state.evaluations = payload.list;
    state.paginaInicial = payload.paginaInicial;
    state.paginaFinal = payload.paginaFinal;
  },
  toggleEvaluationModal: function toggleEvaluationModal(state, value) {
    state.evaluationModal = value;
  },
  loadUsers: function loadUsers(state, payload) {
    state.totalItems = payload.totalItens;
    state.currentPage = payload.paginaAtual;
    state.totalPages = payload.totalPaginas;
    state.itemsPerPage = payload.itensPorPagina;
    state.users = payload.list;
    state.paginaInicial = payload.paginaInicial;
    state.paginaFinal = payload.paginaFinal;
  },
  nextPage: function nextPage(state) {
    state.currentPage++;
  },
  prevPage: function prevPage(state) {
    state.currentPage--;
  },
  changeItemsPerPage: function changeItemsPerPage(state, value) {
    state.itemsPerPage = value;
  },
  resetPage: function resetPage(state) {
    state.currentPage = 1;
  },
  selectUser: function selectUser(state, payload) {
    state.selectedUser.id = payload.id;
    state.selectedUser.nome = payload.nome;
    state.selectedUser.login = payload.login;
    state.selectedUser.telefone = payload.telefone;
    state.selectedUser.email = payload.email;
    state.selectedUser.departamento = payload.departamento;
    state.selectedUser.active = payload.active;
    state.selectedUser.senha = payload.senha;
  },
  appendNewUser: function appendNewUser(state, payload) {
    state.users.push(payload);
  },
  updateRegisteredUsers: function updateRegisteredUsers(state, payload) {
    state.users = state.users.map(function (elem) {
      return elem.id === state.selectedUser.id ? state.selectedUser : elem;
    });
  },
  newUser: function newUser(state) {
    state.selectedUser = {
      id: 0,
      nome: '',
      login: '',
      telefone: '',
      email: '',
      departamento: '',
      active: true,
      senha: ''
    };
  },
  toggleUserActive: function toggleUserActive(state) {
    state.selectedUser.active = !state.selectedUser.active;
  },
  resetUser: function resetUser(state) {
    state.selectedUser = {};
    state.registeredItems = [];
  },
  toggleUserModal: function toggleUserModal(state, value) {
    state.userModal = value;
  },
  updateUserName: function updateUserName(state, value) {
    state.selectedUser.nome = value;
  },
  updateUserLogin: function updateUserLogin(state, value) {
    state.selectedUser.login = value;
  },
  updateUserPassword: function updateUserPassword(state, value) {
    state.selectedUser.senha = value;
  },
  updateUserEmail: function updateUserEmail(state, value) {
    state.selectedUser.email = value;
  },
  updateUserPhone: function updateUserPhone(state, value) {
    state.selectedUser.telefone = value;
  },
  updateUserDepartment: function updateUserDepartment(state, value) {
    state.selectedUser.departamento = value;
  },
  updateWeekdayStart: function updateWeekdayStart(state, value) {
    state.company.weekDayStart = value;
  },
  updateWeekdayEnd: function updateWeekdayEnd(state, value) {
    state.company.weekDayEnd = value;
  },
  updateWeekdayInterval: function updateWeekdayInterval(state, value) {
    state.company.weekDayInterval = value;
  },
  updateWeekdayCapacity: function updateWeekdayCapacity(state, value) {
    state.company.weekDayCapacity = value;
  },
  updateSundayStart: function updateSundayStart(state, value) {
    state.company.sundayStart = value;
  },
  updateSundayEnd: function updateSundayEnd(state, value) {
    state.company.sundayEnd = value;
  },
  updateSundayInterval: function updateSundayInterval(state, value) {
    state.company.sundayInterval = value;
  },
  updateSundayCapacity: function updateSundayCapacity(state, value) {
    state.company.sundayCapacity = value;
  },
  updateMondayStart: function updateMondayStart(state, value) {
    state.company.mondayStart = value;
  },
  updateMondayEnd: function updateMondayEnd(state, value) {
    state.company.mondayEnd = value;
  },
  updateMondayInterval: function updateMondayInterval(state, value) {
    state.company.mondayInterval = value;
  },
  updateMondayCapacity: function updateMondayCapacity(state, value) {
    state.company.mondayCapacity = value;
  },
  updateTuesdayStart: function updateTuesdayStart(state, value) {
    state.company.tuesdayStart = value;
  },
  updateTuesdayEnd: function updateTuesdayEnd(state, value) {
    state.company.tuesdayEnd = value;
  },
  updateTuesdayInterval: function updateTuesdayInterval(state, value) {
    state.company.tuesdayInterval = value;
  },
  updateTuesdayCapacity: function updateTuesdayCapacity(state, value) {
    state.company.tuesdayCapacity = value;
  },
  updateWednesdayStart: function updateWednesdayStart(state, value) {
    state.company.wednesdayStart = value;
  },
  updateWednesdayEnd: function updateWednesdayEnd(state, value) {
    state.company.wednesdayEnd = value;
  },
  updateWednesdayInterval: function updateWednesdayInterval(state, value) {
    state.company.wednesdayInterval = value;
  },
  updateWednesdayCapacity: function updateWednesdayCapacity(state, value) {
    state.company.wednesdayCapacity = value;
  },
  updateThursdayStart: function updateThursdayStart(state, value) {
    state.company.thursdayStart = value;
  },
  updateThursdayEnd: function updateThursdayEnd(state, value) {
    state.company.thursdayEnd = value;
  },
  updateThursdayInterval: function updateThursdayInterval(state, value) {
    state.company.thursdayInterval = value;
  },
  updateThursdayCapacity: function updateThursdayCapacity(state, value) {
    state.company.thursdayCapacity = value;
  },
  updateFridayStart: function updateFridayStart(state, value) {
    state.company.fridayStart = value;
  },
  updateFridayEnd: function updateFridayEnd(state, value) {
    state.company.fridayEnd = value;
  },
  updateFridayInterval: function updateFridayInterval(state, value) {
    state.company.fridayInterval = value;
  },
  updateFridayCapacity: function updateFridayCapacity(state, value) {
    state.company.fridayCapacity = value;
  },
  updateSaturdayStart: function updateSaturdayStart(state, value) {
    state.company.saturdayStart = value;
  },
  updateSaturdayEnd: function updateSaturdayEnd(state, value) {
    state.company.saturdayEnd = value;
  },
  updateSaturdayInterval: function updateSaturdayInterval(state, value) {
    state.company.saturdayInterval = value;
  },
  updateSaturdayCapacity: function updateSaturdayCapacity(state, value) {
    state.company.saturdayCapacity = value;
  },
  toggleNeedSchedule: function toggleNeedSchedule(state) {
    state.company.needSchedule = !state.company.needSchedule;
  },
  toggleCustomTime: function toggleCustomTime(state) {
    state.company.customTime = !state.company.customTime;
  },
  selectAvaliacao: function selectAvaliacao(state, value) {
    for (var i = 0; i < state.evaluations.length; i++) {
      if (state.evaluations[i].id === value) {
        state.selectedAvaliacao = state.evaluations[i];
        state.evaluationModal = true;
        break;
      }
    }
  },
  updateResposta: function updateResposta(state, value) {
    state.selectedAvaliacao.resposta = value;
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var _this = this;



/* harmony default export */ __webpack_exports__["a"] = ({
  getLogoProviderConfirmation: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, data) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      var _ref3, response;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/api/v1/" + 'Hotsite/GetLogo?Type=' + data.type, { headers: { 'Token': data.token } });

            case 2:
              _ref3 = _context.sent;
              response = _ref3.data;

              commit('loadLogoProviderConfirmation', response.resultado);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function getLogoProviderConfirmation(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(),
  getScheduleDetails: function getScheduleDetails(_ref4, payload) {
    var _this2 = this;

    var commit = _ref4.commit,
        rootGetters = _ref4.rootGetters,
        state = _ref4.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                method: 'get',
                url: "/api/v1/" + 'Hotsite/DetalhesAgendamento',
                timeout: 200000,
                headers: {
                  'Token': payload
                }
              }).then(function (response) {
                commit('setScheduleDetails', response.data.resultado);
              }).catch(function (error) {
                console.log(error);
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllInfoConfirmation: function getAllInfoConfirmation(_ref5, data) {
    var _this3 = this;

    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit('toggleLoadingConfirmation', true);
              _context3.prev = 1;
              _context3.next = 4;
              return dispatch('getLogoProviderConfirmation', data);

            case 4:
              _context3.next = 10;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3['catch'](1);

              commit('toastrAxiosError', _context3.t0);
              commit('toggleLoadingConfirmation', false);

            case 10:
              commit('toggleLoadingConfirmation', false);

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[1, 6]]);
    }))();
  },
  sendEmailToCondominiums: function sendEmailToCondominiums(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    var url = 'Agendamento/AnswerByPosition?tipo=' + payload.type + '&tkn=' + payload.token + '&answer=' + payload.send + '&t=2';
    __WEBPACK_IMPORTED_MODULE_2_axios___default()({
      method: 'get',
      url: "/api/v1/" + url,
      timeout: 200000,
      headers: {
        'Token': payload.token
      }
    }).then(function (response) {}).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadingConfirmation: function loadingConfirmation(state) {
    return state.loadingConfirmation;
  },
  logoProviderConfirmation: function logoProviderConfirmation(state) {
    return state.logoProviderConfirmation === '' ? '' : state.logoProviderConfirmation;
  },
  detailsScheduled: function detailsScheduled(state) {
    return state.details;
  },

  typeConfirmation: function typeConfirmation(state) {
    return state.type;
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(267);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadingConfirmation: false,
    logoProviderConfirmation: '',
    details: {
      scheduled: '',
      category: '',
      enterprise: ''
    }
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadLogoProviderConfirmation: function loadLogoProviderConfirmation(state, payload) {
    state.logoProviderConfirmation = payload.logo;
    state.loadingConfirmation = false;
  },
  toggleLoadingConfirmation: function toggleLoadingConfirmation(state, value) {
    state.loadingConfirmation = value;
  },
  setScheduleDetails: function setScheduleDetails(state, value) {
    state.details = value;
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var _this = this;



/* harmony default export */ __webpack_exports__["a"] = ({
  sendHotsiteFeedback: function sendHotsiteFeedback(_ref, token) {
    var commit = _ref.commit,
        rootGetters = _ref.rootGetters,
        state = _ref.state;

    if (state.observation === '') {
      commit('toastr', {
        color: 'error',
        texto: 'É importante deixar seu comentário.'
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Analytics/Feedback',
        timeout: 200000,
        headers: {
          'Token': token
        },
        data: state
      });
    }
  },

  getLogoProvider: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref3, data) {
      var commit = _ref3.commit,
          getters = _ref3.getters;

      var _ref4, response;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/api/v1/" + 'Hotsite/GetLogo?Type=' + data.type, { headers: { 'Token': data.token } });

            case 2:
              _ref4 = _context.sent;
              response = _ref4.data;

              commit('loadLogoProvider', response.resultado);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function getLogoProvider(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(),
  getAllInfoFeedback: function getAllInfoFeedback(_ref5, data) {
    var _this2 = this;

    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit('toggleLoadingFeedback', true);
              _context2.prev = 1;
              _context2.next = 4;
              return dispatch('getLogoProvider', data);

            case 4:
              _context2.next = 10;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2['catch'](1);

              commit('toastrAxiosError', _context2.t0);
              commit('toggleLoadingFeedback', false);

            case 10:
              commit('toggleLoadingFeedback', false);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 6]]);
    }))();
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  observation: function observation(state) {
    return state.observation;
  },
  satisfaction: function satisfaction(state) {
    return state.satisfaction;
  },
  loadingFeedback: function loadingFeedback(state) {
    return state.loadingFeedback;
  },
  logoProviderFeedback: function logoProviderFeedback(state) {
    return state.logoProviderFeedback === '' ? '' : state.logoProviderFeedback;
  },

  type: function type(state) {
    return state.type;
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(271);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    observation: '',
    satisfaction: '',
    loadingFeedback: false,
    logoProviderFeedback: ''
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  updateObservation: function updateObservation(state, value) {
    state.observation = value;
  },
  updateSatisfaction: function updateSatisfaction(state, value) {
    state.satisfaction = value;
  },
  loadLogoProvider: function loadLogoProvider(state, payload) {
    state.logoProviderFeedback = payload.logo;
    state.loadingFeedback = false;
  },
  toggleLoadingFeedback: function toggleLoadingFeedback(state, value) {
    state.loadingFeedback = value;
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  changeActivation: function changeActivation(_ref, payload) {
    var state = _ref.state,
        commit = _ref.commit,
        rootGetters = _ref.rootGetters;

    commit('changeActivation', payload.id);
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      method: 'post',
      url: "/api/v1/" + 'Itens/AtivaDesativa',
      timeout: 200000,
      headers: {
        'Token': rootGetters.token
      },
      data: payload
    }).then(function (response) {
      commit('toastr', {
        color: 'success',
        texto: 'Visibilidade alterada'
      });
    }).catch(function (error) {
      if (error.request.response !== '') {
        var erros = JSON.parse(error.request.response).preErros;
        var description = '';
        if (erros.length > 0) {
          erros.forEach(function (element) {
            description = description + ' ' + element;
          });
        } else {
          description = erros[0];
        }
        if (erros !== undefined) {
          commit('toastr', {
            color: 'error',
            texto: description
          });
        }
      }
      commit('toggleLoadingMounted', false);
      commit('toastrAxiosError', error);
    });
  },
  getItems: function getItems(_ref2, id) {
    var state = _ref2.state,
        commit = _ref2.commit;

    commit('toggleLoadingMounted', true);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      window.http.get('Itens/GetAll').then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadRegisteredItems', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toastrAxiosError', error);
      });
    });
  },
  deleteItem: function deleteItem(_ref3, itemId) {
    var state = _ref3.state,
        commit = _ref3.commit,
        rootGetters = _ref3.rootGetters;

    commit('toggleLoadingMounted', true);
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({
      method: 'post',
      url: "/api/v1/" + 'Itens/Remove?id=' + itemId,
      timeout: 200000,
      headers: {
        'Token': rootGetters.token
      }
    }).then(function (response) {
      commit('toggleLoadingMounted', false);
      commit('deleteItem', itemId);
      commit('toastr', {
        color: 'success',
        texto: 'Item deletado com sucesso'
      });
    }).catch(function (error) {
      if (error.request.response !== '') {
        var erros = JSON.parse(error.request.response).preErros;
        var description = '';
        if (erros.length > 0) {
          erros.forEach(function (element) {
            description = description + ' ' + element;
          });
        } else {
          description = erros[0];
        }
        if (erros !== undefined) {
          commit('toastr', {
            color: 'error',
            texto: description
          });
        }
      }
      commit('toggleLoadingMounted', false);
      commit('toastrAxiosError', error);
    });
  },
  updateItem: function updateItem(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit,
        rootGetters = _ref4.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // window.http.post('Itens/Salvar', queryString.stringify(JSON.stringify(state.selectedItem)))
      var form = new FormData();
      for (var key in state.selectedItem) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(state.selectedItem[key]) === 'object') {
          form.append(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.selectedItem[key]));
        } else {
          form.append(key, state.selectedItem[key]);
        }
      }
      form.append('Img', state.selectedItem.image);
      commit('toggleLoadingItemAction', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Itens/Salvar',
        timeout: 200000,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token': rootGetters.token
        },
        data: form
      }).then(function (response) {
        commit('toggleLoadingItemAction', false);
        var data = response.data;
        if (data.preErros.length > 0) {
          // commit('toastrApiError', data.preErros)
          reject(data);
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          });
          // TODO: Integrar a api com erros[]
        } else {
          if (data.preErros.length > 0) {
            commit('toastr', {
              color: 'error',
              texto: data.preErros[0]
            });
          } else {
            if (state.selectedItem.id === '') {
              commit('appendNewItem', data.resultado);
              commit('toggleItemModal', false);
              commit('toastr', {
                color: 'success',
                texto: 'Item cadastrado com sucesso'
              });
            } else {
              commit('updateRegisteredItems', data.resultado);
              commit('toastr', {
                color: 'success',
                texto: 'Item atualizado com sucesso'
              });
            }
          }
          resolve();
        }
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingItemAction', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  selectItem: function selectItem(_ref5, id) {
    var state = _ref5.state,
        commit = _ref5.commit;

    if (id === '') {
      commit('newItem');
      commit('toggleItemModal', true);
      return;
    } else {
      commit('toggleLoadingMounted', true);
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        window.http.get('Itens/GetDetalhe?registro=' + id).then(function (response) {
          commit('toggleLoadingMounted', false);
          commit('selectItem', response.data.resultado);
          commit('toggleItemModal', true);
        }).catch(function (error) {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros;
            var description = '';
            if (erros.length > 0) {
              erros.forEach(function (element) {
                description = description + ' ' + element;
              });
            } else {
              description = erros[0];
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              });
            }
          }
          commit('toastrAxiosError', error);
        });
      });
    }
  },
  shelfImage: function shelfImage(_ref6, value) {
    var state = _ref6.state,
        commit = _ref6.commit;

    var reader = new FileReader();
    commit('updateImage', value);
    reader.onload = function (e) {
      state.imageNotSent = e.target.result;
    };
    reader.readAsDataURL(value);
  },
  uploadItemImage: function uploadItemImage(_ref7, image) {
    var state = _ref7.state,
        commit = _ref7.commit,
        rootGetters = _ref7.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var form = new FormData();
      form.append('cropX', state.itemVariationImage.imageCropX);
      form.append('cropY', state.itemVariationImage.imageCropY);
      form.append('cropW', state.itemVariationImage.imageCropW);
      form.append('cropH', state.itemVariationImage.imageCropH);
      form.append('image', image);
      commit('toggleLoadingItemAction', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Itens/UploadItemImage',
        timeout: 200000,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token': rootGetters.token
        },
        data: form
      }).then(function (response) {
        commit('toggleLoadingItemAction', false);
        var data = response.data;
        if (data.preErros.length > 0) {
          reject(data);
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          });
          // TODO: Integrar a api com erros[]
        } else {
          commit('updateMultiPriceImage', { index: state.imgUploadIndex, value: data.resultado });
          commit('toggleImgUploadModal', false);
        }
        resolve();
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingItemAction', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getCoupons: function getCoupons(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit;

    commit('toggleLoadingMounted', true);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      window.http.get('CupomDesconto/GetListaByFornecedor?page=' + state.cupomCurrentPage + '&pageItems=' + state.cupomItemsPerPage).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadCupoms', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toastrAxiosError', error);
      });
    });
  },
  selectCupom: function selectCupom(_ref9, id) {
    var state = _ref9.state,
        commit = _ref9.commit;

    if (id === '') {
      commit('newCupom');
      commit('toggleCupomModal', true);
      return;
    } else {
      commit('toggleLoadingMounted', true);
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        window.http.get('CupomDesconto/Get?id=' + id).then(function (response) {
          commit('toggleLoadingMounted', false);
          commit('selectCupom', response.data.resultado);
          commit('toggleCupomModal', true);
        }).catch(function (error) {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros;
            var description = '';
            if (erros.length > 0) {
              erros.forEach(function (element) {
                description = description + ' ' + element;
              });
            } else {
              description = erros[0];
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              });
            }
          }
          commit('toastrAxiosError', error);
        });
      });
    }
  },
  updateCupom: function updateCupom(_ref10) {
    var state = _ref10.state,
        commit = _ref10.commit,
        rootGetters = _ref10.rootGetters;

    state.selectedCupom.amount = state.selectedCupom.amount / 100;
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingCupomAction', true);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'CupomDesconto/Save',
        timeout: 200000,
        headers: { 'Token': rootGetters.token },
        data: state.selectedCupom
      }).then(function (response) {
        commit('toggleLoadingCupomAction', false);
        var data = response.data;
        if (data.preErros.length > 0) {
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          });
        } else {
          if (state.selectedCupom.id === 0) {
            commit('appendNewCupom', data.resultado);
            commit('toggleCupomModal', false);
            commit('toastr', {
              color: 'success',
              texto: 'Cupom cadastrado com sucesso'
            });
          } else {
            commit('updateRegisteredCupons', data.resultado);
            commit('toastr', {
              color: 'success',
              texto: 'Cupom atualizado com sucesso'
            });
          }
        }
        resolve();
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingCupomAction', false);
        commit('toastrAxiosError', error);
      });
    });
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  itemVisible: function itemVisible(state) {
    return state.itemModal;
  },
  selectedItem: function selectedItem(state) {
    return state.selectedItem;
  },
  selectedItemPrice: function selectedItemPrice(state) {
    return state.selectedItem.price;
  },
  selectedItemPriceTable: function selectedItemPriceTable(state) {
    return state.selectedItem.priceTable;
  },
  selectedItemPriceVariations: function selectedItemPriceVariations(state) {
    return state.selectedItem.priceVariations;
  },
  registeredItems: function registeredItems(state) {
    return state.registeredItems;
  },
  registeredItemsActive: function registeredItemsActive(state) {
    return state.registeredItems.filter(function (elem) {
      return elem.active;
    });
  },
  loadingItemAction: function loadingItemAction(state) {
    return state.loadingItemAction;
  },
  termsOfUseContent: function termsOfUseContent(state) {
    return state.selectedItem.termsOfUseContent;
  },
  isImg: function isImg(state) {
    return state.selectedItem.images !== null && state.selectedItem.images.length > 0;
  },
  shelfedImage: function shelfedImage(state) {
    return state.imageNotSent;
  },
  imgUploadVisible: function imgUploadVisible(state) {
    return state.imgUploadModal;
  },
  imgUploadIndex: function imgUploadIndex(state) {
    return state.imgUploadIndex;
  },
  cupoms: function cupoms(state) {
    return state.cupoms;
  },
  selectedCupom: function selectedCupom(state) {
    return state.selectedCupom;
  },
  cupomVisible: function cupomVisible(state) {
    return state.cupomModal;
  },
  cupomCurrentPage: function cupomCurrentPage(state) {
    return state.cupomCurrentPage;
  },
  cupomTotalPages: function cupomTotalPages(state) {
    return state.cupomTotalPages;
  },
  cupomTotalItems: function cupomTotalItems(state) {
    return state.cupomTotalItems;
  },
  cupomItemsPerPage: function cupomItemsPerPage(state) {
    return state.cupomItemsPerPage;
  },
  loadingCupomAction: function loadingCupomAction(state) {
    return state.loadingCupomAction;
  },
  listItens: function listItens(state) {
    return state.listItens;
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(275);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    itemModal: false,
    imgUploadModal: false,
    loadingItemAction: false,
    imgUploadImage: '',
    imgUploadIndex: 0,
    itemVariationImage: {
      imageCropH: 0,
      imageCropW: 0,
      imageCropX: 0,
      imageCropY: 0
    },
    selectedItem: {
      id: '',
      name: '',
      code: '',
      description: '',
      termsOfUseContent: '',
      realizationTime: '',
      active: '',
      tags: '',
      categoriesWithRegister: '',
      categories: '',
      family: '',
      seq: 0,
      validityStart: '',
      validityEnd: '',
      price: null,
      priceVariations: '',
      idProvider: '',
      priceTable: '',
      payment: '',
      image: '',
      images: [],
      imageCropH: 0,
      imageCropW: 0,
      imageCropX: 0,
      imageCropY: 0,
      needSchedule: false,
      customTime: false,
      weekDayStart: '',
      weekDayEnd: '',
      weekDayInterval: '',
      weekDayCapacity: 0,
      sundayStart: '',
      sundayEnd: '',
      sundayInterval: '',
      sundayCapacity: 0,
      mondayStart: '',
      mondayEnd: '',
      mondayInterval: '',
      mondayCapacity: 0,
      tuesdayStart: '',
      tuesdayEnd: '',
      tuesdayInterval: '',
      tuesdayCapacity: 0,
      wednesdayStart: '',
      wednesdayEnd: '',
      wednesdayInterval: '',
      wednesdayCapacity: 0,
      thursdayStart: '',
      thursdayEnd: '',
      thursdayInterval: '',
      thursdayCapacity: 0,
      fridayStart: '',
      fridayEnd: '',
      fridayInterval: '',
      fridayCapacity: 0,
      saturdayStart: '',
      saturdayEnd: '',
      saturdayInterval: '',
      saturdayCapacity: 0
    },
    imageNotSent: '',
    registeredItems: [],
    cupoms: [],
    cupomCurrentPage: 1,
    cupomTotalItems: 0,
    cupomTotalPages: 0,
    cupomPaginaInicial: 0,
    cupomPaginaFinal: 0,
    cupomItemsPerPage: 12,
    selectedCupom: {
      id: 0,
      name: '',
      idFornecedor: 0,
      type: 0,
      amount: 0,
      code: null,
      start: null,
      end: null,
      limitationType: 0,
      limitation: null,
      observation: '',
      region: false,
      administradoras: false,
      condominios: false,
      produtos: false,
      active: false,
      approved: false,
      servicoProdutosList: null
    },
    cupomModal: false,
    loadingCupomAction: false
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  selectItem: function selectItem(state, value) {
    state.selectedItem = value;
    state.imageNotSent = '';
  },
  appendNewItem: function appendNewItem(state, payload) {
    state.registeredItems.push(payload);
  },
  updateRegisteredItems: function updateRegisteredItems(state, payload) {
    state.registeredItems = state.registeredItems.map(function (elem) {
      return elem.id === state.selectedItem.id ? payload : elem;
    });
  },
  deleteItem: function deleteItem(state, value) {
    state.registeredItems = state.registeredItems.filter(function (elem) {
      return elem.id !== value;
    });
  },
  newItem: function newItem(state) {
    state.selectedItem = {
      active: true,
      categories: '',
      payments: [],
      photos: [],
      code: '',
      description: '',
      termsOfUseContent: '',
      family: ' ',
      seq: 0,
      id: '',
      name: '',
      price: null,
      priceTable: [],
      priceVariations: false,
      realizationTime: ' ',
      tags: [],
      validityEnd: null,
      validityStart: null,
      image: '',
      images: [],
      imageCropH: 0,
      imageCropW: 0,
      imageCropX: 0,
      imageCropY: 0,
      needSchedule: false,
      customTime: false,
      weekDayStart: '',
      weekDayEnd: '',
      weekDayInterval: '',
      weekDayCapacity: 0,
      sundayStart: '',
      sundayEnd: '',
      sundayInterval: '',
      sundayCapacity: 0,
      mondayStart: '',
      mondayEnd: '',
      mondayInterval: '',
      mondayCapacity: 0,
      tuesdayStart: '',
      tuesdayEnd: '',
      tuesdayInterval: '',
      tuesdayCapacity: 0,
      wednesdayStart: '',
      wednesdayEnd: '',
      wednesdayInterval: '',
      wednesdayCapacity: 0,
      thursdayStart: '',
      thursdayEnd: '',
      thursdayInterval: '',
      thursdayCapacity: 0,
      fridayStart: '',
      fridayEnd: '',
      fridayInterval: '',
      fridayCapacity: 0,
      saturdayStart: '',
      saturdayEnd: '',
      saturdayInterval: '',
      saturdayCapacity: 0
    };
  },
  toggleLoadingItemAction: function toggleLoadingItemAction(state, value) {
    state.loadingItemAction = value;
  },
  loadRegisteredItems: function loadRegisteredItems(state, value) {
    state.registeredItems = value;
  },
  changeActivation: function changeActivation(state, value) {
    var index = state.registeredItems.findIndex(function (item) {
      return item.id === value;
    });
    state.registeredItems[index].active = !state.registeredItems[index].active;
  },
  toggleActive: function toggleActive(state) {
    state.selectedItem.active = !state.selectedItem.active;
  },
  addPhoto: function addPhoto(state, value) {
    state.selectedItem.photos.push(value);
  },
  removePhoto: function removePhoto(state, value) {
    state.selectedItem.photos.splice(state.item.selectedItem.indexOf(value), 1);
    state.selectedItem.photos = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.selectedItem.photos));
  },
  updateName: function updateName(state, value) {
    state.selectedItem.name = value;
  },
  updateDescription: function updateDescription(state, value) {
    state.selectedItem.description = value;
  },
  updateTermsOfUseContent: function updateTermsOfUseContent(state, value) {
    state.selectedItem.termsOfUseContent = value;
  },
  updateCode: function updateCode(state, value) {
    state.selectedItem.code = value;
  },
  updateRealizationTime: function updateRealizationTime(state, value) {
    state.selectedItem.realizationTime = value;
  },
  addTag: function addTag(state, value) {
    if (state.selectedItem.tags.length > 0) {
      if (state.selectedItem.tags.indexOf(value) !== -1) {
        return false;
      } else {
        state.selectedItem.tags.push(value);
      }
    } else {
      (state.selectedItem.tags = []).push(value);
    }
  },
  removeTag: function removeTag(state, value) {
    state.selectedItem.tags.splice(state.selectedItem.tags.indexOf(value), 1);
    state.selectedItem.tags = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.selectedItem.tags));
  },
  updateValidityStart: function updateValidityStart(state, value) {
    state.selectedItem.validityStart = value;
  },
  updateValidityEnd: function updateValidityEnd(state, value) {
    state.selectedItem.validityEnd = value;
  },
  updateCategories: function updateCategories(state, value) {
    state.selectedItem.categories = value;
  },
  updateFamily: function updateFamily(state, value) {
    state.selectedItem.family = value;
  },
  updateSeq: function updateSeq(state, value) {
    state.selectedItem.seq = value;
  },
  togglePriceVariations: function togglePriceVariations(state) {
    state.selectedItem.priceVariations = !state.selectedItem.priceVariations;
    if (state.selectedItem.priceTable.length === 0) {
      state.selectedItem.priceTable.push({ price: null, description: '', priceRef: null });
    }
  },
  updateSinglePrice: function updateSinglePrice(state, value) {
    state.selectedItem.price = value;
  },
  updateMultiPrice: function updateMultiPrice(state, payload) {
    state.selectedItem.priceTable[payload.index].price = payload.value;
  },
  updatePriceText: function updatePriceText(state, payload) {
    state.selectedItem.priceTable[payload.index].description = payload.value;
  },
  updateMultiPriceRef: function updateMultiPriceRef(state, payload) {
    state.selectedItem.priceTable[payload.index].priceRef = payload.value;
  },
  updateMultiPriceImage: function updateMultiPriceImage(state, payload) {
    state.selectedItem.priceTable[payload.index].image = payload.value;
  },
  deleteMultiPrice: function deleteMultiPrice(state, payload) {
    if (state.selectedItem.priceTable.length === 1) {
      state.selectedItem.priceTable = [{ price: '', description: '', priceRef: '', image: '' }];
    } else {
      state.selectedItem.priceTable = state.selectedItem.priceTable.filter(function (elem, index) {
        return index !== payload;
      });
    }
  },
  addMultiPrice: function addMultiPrice(state) {
    state.selectedItem.priceTable.push({ price: '', description: '', priceRef: '', image: '' });
  },
  toggleItemModal: function toggleItemModal(state, value) {
    state.itemModal = value;
  },
  updatePayments: function updatePayments(state, value) {
    state.selectedItem.payments = value;
  },
  resetItem: function resetItem(state) {
    state.selectedItem = {};
    state.registeredItems = [];
  },
  unshelfImage: function unshelfImage(state, value) {
    state.imageNotSent = '';
  },
  updateImage: function updateImage(state, value) {
    state.selectedItem.image = value;
    state.selectedItem.images = [];
  },
  updateImageCrop: function updateImageCrop(state, value) {
    state.selectedItem.imageCropH = parseInt(value.height);
    state.selectedItem.imageCropW = parseInt(value.width);
    state.selectedItem.imageCropY = parseInt(value.y);
    state.selectedItem.imageCropX = parseInt(value.x);
  },
  updateWeekdayStart: function updateWeekdayStart(state, value) {
    state.selectedItem.weekDayStart = value;
  },
  updateWeekdayEnd: function updateWeekdayEnd(state, value) {
    state.selectedItem.weekDayEnd = value;
  },
  updateWeekdayInterval: function updateWeekdayInterval(state, value) {
    state.selectedItem.weekDayInterval = value;
  },
  updateWeekdayCapacity: function updateWeekdayCapacity(state, value) {
    state.selectedItem.weekDayCapacity = value;
  },
  updateSundayStart: function updateSundayStart(state, value) {
    state.selectedItem.sundayStart = value;
  },
  updateSundayEnd: function updateSundayEnd(state, value) {
    state.selectedItem.sundayEnd = value;
  },
  updateSundayInterval: function updateSundayInterval(state, value) {
    state.selectedItem.sundayInterval = value;
  },
  updateSundayCapacity: function updateSundayCapacity(state, value) {
    state.selectedItem.sundayCapacity = value;
  },
  updateMondayStart: function updateMondayStart(state, value) {
    state.selectedItem.mondayStart = value;
  },
  updateMondayEnd: function updateMondayEnd(state, value) {
    state.selectedItem.mondayEnd = value;
  },
  updateMondayInterval: function updateMondayInterval(state, value) {
    state.selectedItem.mondayInterval = value;
  },
  updateMondayCapacity: function updateMondayCapacity(state, value) {
    state.selectedItem.mondayCapacity = value;
  },
  updateTuesdayStart: function updateTuesdayStart(state, value) {
    state.selectedItem.tuesdayStart = value;
  },
  updateTuesdayEnd: function updateTuesdayEnd(state, value) {
    state.selectedItem.tuesdayEnd = value;
  },
  updateTuesdayInterval: function updateTuesdayInterval(state, value) {
    state.selectedItem.tuesdayInterval = value;
  },
  updateTuesdayCapacity: function updateTuesdayCapacity(state, value) {
    state.selectedItem.tuesdayCapacity = value;
  },
  updateWednesdayStart: function updateWednesdayStart(state, value) {
    state.selectedItem.wednesdayStart = value;
  },
  updateWednesdayEnd: function updateWednesdayEnd(state, value) {
    state.selectedItem.wednesdayEnd = value;
  },
  updateWednesdayInterval: function updateWednesdayInterval(state, value) {
    state.selectedItem.wednesdayInterval = value;
  },
  updateWednesdayCapacity: function updateWednesdayCapacity(state, value) {
    state.selectedItem.wednesdayCapacity = value;
  },
  updateThursdayStart: function updateThursdayStart(state, value) {
    state.selectedItem.thursdayStart = value;
  },
  updateThursdayEnd: function updateThursdayEnd(state, value) {
    state.selectedItem.thursdayEnd = value;
  },
  updateThursdayInterval: function updateThursdayInterval(state, value) {
    state.selectedItem.thursdayInterval = value;
  },
  updateThursdayCapacity: function updateThursdayCapacity(state, value) {
    state.selectedItem.thursdayCapacity = value;
  },
  updateFridayStart: function updateFridayStart(state, value) {
    state.selectedItem.fridayStart = value;
  },
  updateFridayEnd: function updateFridayEnd(state, value) {
    state.selectedItem.fridayEnd = value;
  },
  updateFridayInterval: function updateFridayInterval(state, value) {
    state.selectedItem.fridayInterval = value;
  },
  updateFridayCapacity: function updateFridayCapacity(state, value) {
    state.selectedItem.fridayCapacity = value;
  },
  updateSaturdayStart: function updateSaturdayStart(state, value) {
    state.selectedItem.saturdayStart = value;
  },
  updateSaturdayEnd: function updateSaturdayEnd(state, value) {
    state.selectedItem.saturdayEnd = value;
  },
  updateSaturdayInterval: function updateSaturdayInterval(state, value) {
    state.selectedItem.saturdayInterval = value;
  },
  updateSaturdayCapacity: function updateSaturdayCapacity(state, value) {
    state.selectedItem.saturdayCapacity = value;
  },
  toggleNeedSchedule: function toggleNeedSchedule(state) {
    state.selectedItem.needSchedule = !state.selectedItem.needSchedule;
  },
  toggleCustomTime: function toggleCustomTime(state) {
    state.selectedItem.customTime = !state.selectedItem.customTime;
  },
  toggleImgUploadModal: function toggleImgUploadModal(state, value) {
    state.imgUploadModal = value;
  },
  updateImgUploadImage: function updateImgUploadImage(state, value) {
    state.imgUploadImage = value;
  },
  updateImgUploadIndex: function updateImgUploadIndex(state, value) {
    state.imgUploadIndex = value;
  },
  updateImgUploadCrop: function updateImgUploadCrop(state, value) {
    state.itemVariationImage.imageCropH = parseInt(value.height);
    state.itemVariationImage.imageCropW = parseInt(value.width);
    state.itemVariationImage.imageCropY = parseInt(value.y);
    state.itemVariationImage.imageCropX = parseInt(value.x);
  },
  loadCupoms: function loadCupoms(state, value) {
    state.totalItems = value.totalItens;
    state.currentPage = value.paginaAtual;
    state.totalPages = value.totalPaginas;
    state.cupoms = value.list;
    state.paginaInicial = value.paginaInicial;
    state.paginaFinal = value.paginaFinal;
  },
  cupomNextPage: function cupomNextPage(state) {
    state.cupomCurrentPage++;
  },
  cupomPrevPage: function cupomPrevPage(state) {
    state.cupomCurrentPage--;
  },
  selectCupom: function selectCupom(state, payload) {
    state.selectedCupom = payload;
  },
  toggleCupomModal: function toggleCupomModal(state, value) {
    state.cupomModal = value;
  },
  toggleLoadingCupomAction: function toggleLoadingCupomAction(state, value) {
    state.loadingCupomAction = value;
  },
  appendNewCupom: function appendNewCupom(state, payload) {
    state.cupoms.push(payload);
  },
  updateRegisteredCupons: function updateRegisteredCupons(state, payload) {
    state.cupoms = state.cupoms.map(function (elem) {
      return elem.id === state.selectedCupom.id ? payload : elem;
    });
  },
  changeItemsPerPage: function changeItemsPerPage(state, value) {
    state.cupomItemsPerPage = value;
  },
  cupomResetPage: function cupomResetPage(state) {
    state.cupomCurrentPage = 1;
  },
  updateCupomName: function updateCupomName(state, value) {
    state.selectedCupom.name = value;
  },
  updateCupomType: function updateCupomType(state, value) {
    state.selectedCupom.type = value;
  },
  updateCupomAmount: function updateCupomAmount(state, value) {
    state.selectedCupom.amount = value;
  },
  updateCupomCode: function updateCupomCode(state, value) {
    state.selectedCupom.code = value;
  },
  updateCupomStart: function updateCupomStart(state, value) {
    state.selectedCupom.start = value;
  },
  updateCupomEnd: function updateCupomEnd(state, value) {
    state.selectedCupom.end = value;
  },
  updateCupomLimitationType: function updateCupomLimitationType(state, value) {
    state.selectedCupom.limitationType = value;
  },
  updateCupomLimitation: function updateCupomLimitation(state, value) {
    state.selectedCupom.limitation = value;
  },
  updateCupomObservation: function updateCupomObservation(state, value) {
    state.selectedCupom.observation = value;
  },
  updateCupomProducts: function updateCupomProducts(state, value) {
    state.selectedCupom.products = value;
  },
  updateCupomActive: function updateCupomActive(state, value) {
    state.selectedCupom.active = value;
  },
  toggleProdutos: function toggleProdutos(state) {
    state.selectedCupom.produtos = !state.selectedCupom.produtos;
  },
  newCupom: function newCupom(state) {
    state.selectedCupom = {
      id: 0,
      name: '',
      idFornecedor: 0,
      type: 0,
      amount: 0,
      code: null,
      start: null,
      end: null,
      limitationType: 0,
      limitation: null,
      observation: '',
      region: false,
      administradoras: false,
      condominios: false,
      produtos: false,
      active: false,
      approved: false,
      servicoProdutosList: null
    };
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  deleteNotification: function deleteNotification(_ref, value) {
    var state = _ref.state,
        commit = _ref.commit;

    var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
      timeout: 200000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    http.post('http://homologacao2.hotvia.com.br/imagens/index.php', value).then(function (response) {
      commit('deleteNotification', response.data);
    });
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  notificacao: function notificacao(state) {
    return state.notificacao;
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(279);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    notificacao: [
      // {
      //   url: 'Pedidos/Novos',
      //   quantidade: 0
      // }
    ]
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  deleteNotification: function deleteNotification(state, value) {
    state.notificacao = state.notificacao.filter(function (elem) {
      return elem.url !== value;
    });
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  selectOrder: function selectOrder(_ref, id) {
    var state = _ref.state,
        commit = _ref.commit,
        rootGetters = _ref.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/Detail?id=' + id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('toggleOrderDetailsModal', true);
        commit('loadOrderDetails', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  cancelOrder: function cancelOrder(_ref2) {
    var state = _ref2.state,
        commit = _ref2.commit,
        rootGetters = _ref2.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      commit('toggleLoadingOrderActions', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Pedido/Cancel?provider=' + state.selectedOrder.id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('toggleLoadingOrderActions', false);
        commit('updateRegisteredOrders', response.data.resultado);
        commit('toggleOrderDetailsModal', false);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toggleLoadingOrderActions', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  acceptOrder: function acceptOrder(_ref3) {
    var state = _ref3.state,
        commit = _ref3.commit,
        rootGetters = _ref3.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      commit('toggleLoadingOrderActions', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Pedido/Accept?provider=' + state.selectedOrder.id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('toggleLoadingOrderActions', false);
        commit('updateRegisteredOrders', response.data.resultado);
        commit('toggleOrderDetailsModal', false);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toggleLoadingOrderActions', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getAllOrders: function getAllOrders(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit,
        rootGetters = _ref4.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/All?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadOrders', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getFeaturedNewOrders: function getFeaturedNewOrders(_ref5) {
    var state = _ref5.state,
        commit = _ref5.commit,
        rootGetters = _ref5.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingFeatured', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/New?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingFeatured', false);
        commit('loadOrders', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingFeatured', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getNewOrders: function getNewOrders(_ref6) {
    var state = _ref6.state,
        commit = _ref6.commit,
        rootGetters = _ref6.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/New?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadOrders', response.data.resultado);
      }).catch(function (error) {
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getInProgressOrders: function getInProgressOrders(_ref7) {
    var state = _ref7.state,
        commit = _ref7.commit,
        rootGetters = _ref7.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/InProgress?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadOrders', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getFinishedOrders: function getFinishedOrders(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit,
        rootGetters = _ref8.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/Finished?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadOrders', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  getCanceledOrders: function getCanceledOrders(_ref9) {
    var state = _ref9.state,
        commit = _ref9.commit,
        rootGetters = _ref9.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/Canceled?pageItems=' + state.itemsPerPage + '&page=' + state.currentPage,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('loadOrders', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  },
  printOrder: function printOrder(_ref10, id) {
    var state = _ref10.state,
        commit = _ref10.commit,
        rootGetters = _ref10.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true);
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Pedido/Print?id=' + id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false);
        commit('toggleOrderDetailsModal', true);
        commit('loadOrderPrint', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false);
        commit('toastrAxiosError', error);
      });
    });
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  registeredOrders: function registeredOrders(state) {
    return state.registeredOrders;
  },
  loadingFeatured: function loadingFeatured(state) {
    return state.loadingFeatured;
  },
  newOrders: function newOrders(state) {
    return state.registeredOrders.filter(function (elem) {
      return elem.status === 'A';
    });
  },
  inProgressOrders: function inProgressOrders(state) {
    return state.registeredOrders.filter(function (elem) {
      return elem.status === 'L';
    });
  },
  finishedOrders: function finishedOrders(state) {
    return state.registeredOrders.filter(function (elem) {
      return elem.status === 'C';
    });
  },
  canceledOrders: function canceledOrders(state) {
    return state.registeredOrders.filter(function (elem) {
      return elem.status === 'X';
    });
  },
  orderDetailsModal: function orderDetailsModal(state) {
    return state.orderDetailsModal;
  },
  selectedOrder: function selectedOrder(state) {
    return state.selectedOrder;
  },
  loadingOrderActions: function loadingOrderActions(state) {
    return state.loadingOrderActions;
  },
  searchOrders: function searchOrders(state) {
    return state.searchOrders;
  },
  currentPage: function currentPage(state) {
    return state.currentPage;
  },
  totalPages: function totalPages(state) {
    return state.totalPages;
  },
  totalItems: function totalItems(state) {
    return state.totalItems;
  },
  itemsPerPage: function itemsPerPage(state) {
    return state.itemsPerPage;
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(283);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    registeredOrders: [],
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    itemsPerPage: 12,
    selectedOrder: {},
    paginaInicial: 0,
    paginaFinal: 0,
    orderDetailsModal: false,
    loadingOrderActions: false,
    loadingFeatured: false,
    searchOrders: '',
    orderPdf: ''
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  toggleOrderDetailsModal: function toggleOrderDetailsModal(state, value) {
    state.orderDetailsModal = value;
  },
  loadOrders: function loadOrders(state, payload) {
    state.totalItems = payload.totalItens;
    state.currentPage = payload.paginaAtual;
    state.totalPages = payload.totalPaginas;
    state.itemsPerPage = payload.itensPorPagina;
    state.registeredOrders = payload.list;
    state.paginaInicial = payload.paginaInicial;
    state.paginaFinal = payload.paginaFinal;
  },
  loadOrderDetails: function loadOrderDetails(state, payload) {
    state.selectedOrder = payload;
  },
  updateRegisteredOrders: function updateRegisteredOrders(state, payload) {
    state.registeredOrders = state.registeredOrders.filter(function (elm) {
      return elm.id !== state.selectedOrder.id;
    });
  },
  updateOrderReason: function updateOrderReason(state, value) {
    state.selectedOrder.idReason = value;
  },
  toggleLoadingOrderActions: function toggleLoadingOrderActions(state, value) {
    state.loadingOrderActions = value;
  },
  resetPedido: function resetPedido(state) {
    state.registeredOrders = [];
  },
  toggleLoadingFeatured: function toggleLoadingFeatured(state, value) {
    state.loadingFeatured = value;
  },
  updateSearchOrders: function updateSearchOrders(state, value) {
    state.searchOrders = value;
  },
  nextPage: function nextPage(state) {
    state.currentPage++;
  },
  prevPage: function prevPage(state) {
    state.currentPage--;
  },
  changeItemsPerPage: function changeItemsPerPage(state, value) {
    state.itemsPerPage = value;
  },
  loadOrderPrint: function loadOrderPrint(state, payload) {
    state.orderPdf = payload;
    console.log(payload);
    var link = document.createElement('a');
    link.href = "/api/v1/" + '../../' + payload;
    link.target = '_blank';
    link.setAttribute('download', 'pedido.pdf');
    document.body.appendChild(link);
    link.click();
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  resetPedidos: function resetPedidos(_ref) {
    var state = _ref.state,
        commit = _ref.commit,
        rootGetters = _ref.rootGetters;

    commit('resetPedidos');
  },
  getOrdersReport: function getOrdersReport(_ref2, payload) {
    var state = _ref2.state,
        commit = _ref2.commit,
        rootGetters = _ref2.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'post',
        url: "/api/v1/" + 'Reports/GetOrders',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: payload
      }).then(function (response) {
        commit('toggleLoadingMounted', false, { root: true });
        commit('setPedidos', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('shared/toggleLoadingMounted', false, { root: true });
        commit('toastrAxiosError', error);
      });
    });
  },
  getStatusRelatorio: function getStatusRelatorio(_ref3, payload) {
    var state = _ref3.state,
        commit = _ref3.commit,
        rootGetters = _ref3.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Reports/GetStatus',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false, { root: true });
        commit('setStatus', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('shared/toggleLoadingMounted', false, { root: true });
        commit('toastrAxiosError', error);
      });
    });
  },
  getBusinessPartner: function getBusinessPartner(_ref4, payload) {
    var state = _ref4.state,
        commit = _ref4.commit,
        rootGetters = _ref4.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('toggleLoadingMounted', true, { root: true });
      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'get',
        url: "/api/v1/" + 'Reports/GetPartnerBusiness',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      }).then(function (response) {
        commit('toggleLoadingMounted', false, { root: true });
        commit('setFornecedores', response.data.resultado);
      }).catch(function (error) {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros;
          var description = '';
          if (erros.length > 0) {
            erros.forEach(function (element) {
              description = description + ' ' + element;
            });
          } else {
            description = erros[0];
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            });
          }
        }
        commit('toggleLoadingMounted', false, { root: true });
        commit('toastrAxiosError', error);
      });
    });
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import moment from 'moment'
// import 'moment/locale/pt-br'
/* harmony default export */ __webpack_exports__["a"] = ({
  pedidosReport: function pedidosReport(state) {
    return state.pedidosReport;
  },
  statusOrder: function statusOrder(state) {
    return state.statusOrder;
  },
  fornecedores: function fornecedores(state) {
    return state.business;
  },
  statusName: function statusName(state) {
    var status = state.statusOrder.map(function (elem) {
      return elem.name;
    });
    return status;
  },
  fornecedoresDescription: function fornecedoresDescription(state) {
    var fornecedores = state.business.map(function (elem) {
      return elem.name;
    });
    return fornecedores;
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(287);




var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: namespaced,
  state: function state() {
    return {
      statusOrder: [],
      business: [],
      pedidosReport: []
    };
  },

  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_locale_pt_br__);



/* harmony default export */ __webpack_exports__["a"] = ({
  resetPedidos: function resetPedidos(state) {
    state.pedidosReport = [];
  },
  setPedidos: function setPedidos(state, value) {
    var totalPrice = 0;
    var result = value.reduce(function (res, obj) {
      var price = 0;
      var qtde = 0;
      var items = obj.itens.map(function (elem) {
        price += elem.count * elem.price;
        qtde++;
        return elem.name;
      });
      items = items.join(', ');
      totalPrice += price;
      if (typeof price !== 'number') price = 0;
      price = price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      var newItem = {
        data: __WEBPACK_IMPORTED_MODULE_0_moment___default()(obj.date).format('DD/MM/YYYY HH:mm'),
        nro: obj.identifier,
        itens: items,
        qtd: qtde,
        fornecedor: obj.fornecedorNome,
        condominio: obj.condominium.name,
        adm: obj.condominium.administrator,
        morador: obj.client,
        email: obj.email,
        phone: obj.phone,
        unidade: obj.unit,
        valor: price
      };
      res.push(newItem);
      return res;
    }, []);
    totalPrice = totalPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    var newItem = {
      data: '',
      nro: '',
      itens: '',
      qtd: '',
      fornecedor: '',
      morador: '',
      email: '',
      phone: '',
      unidade: 'TOTAL',
      valor: totalPrice
    };
    result.push(newItem);
    result.sort(function (a, b) {
      var keyA = new Date(a.data);
      var keyB = new Date(b.data);
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });
    state.pedidosReport = result;
  },
  setStatus: function setStatus(state, value) {
    state.statusOrder = value;
  },
  setFornecedores: function setFornecedores(state, value) {
    state.business = value;
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  uploadImages: function uploadImages(_ref, input) {
    var state = _ref.state,
        commit = _ref.commit;

    var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
      timeout: 200000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    var data = new FormData();
    data.append('userfile', input);
    http.post('http://homologacao2.hotvia.com.br/imagens/index.php', data).then(function (response) {
      commit('addFoto', response.data);
    });
  },
  deleteImages: function deleteImages(_ref2, input) {
    var state = _ref2.state,
        commit = _ref2.commit;

    var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
      timeout: 200000,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    var data = new FormData();
    data.append('remove', input);
    http.post('http://homologacao2.hotvia.com.br/imagens/index.php', data).then(function (response) {
      commit('removeFoto', response.data);
    });
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  loadingMounted: function loadingMounted(state) {
    return state.loadingMounted;
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(291);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loadingMounted: false
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  toggleLoadingMounted: function toggleLoadingMounted(state, value) {
    state.loadingMounted = value;
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  toastr: function toastr(state) {
    return state.toastr;
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(296);



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    toastr: {
      time: 2000,
      color: '',
      visibility: false,
      text: '',
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000
    }
  },
  getters: __WEBPACK_IMPORTED_MODULE_0__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */]
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  toastr: function toastr(state, payload) {
    state.toastr.visibility = true;
    state.toastr.text = payload.texto;
    state.toastr.color = payload.color;
    if (payload.time) {
      state.toastr.time = payload.time;
    } else {
      state.toastr.time = 2000;
    }
  },
  toastrAxiosError: function toastrAxiosError(state, payload) {
    try {
      if (payload.response.status === 401) {
        state.toastr.visibility = true;
        state.toastr.text = 'sua sessão está encerrada';
        state.toastr.color = 'error';
      }
    } catch (error) {
      console.log(error);
      state.toastr.visibility = true;
      state.toastr.text = 'Sem conexão com a internet';
      state.toastr.color = 'info';
    }
  },
  toastrApiError: function toastrApiError(state, payload) {
    state.toastr.visibility = true;
    state.toastr.text = payload[0].errorMessage;
    state.toastr.color = 'info';
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = (function (defaults, extras) {
  defaults = defaults || {};
  extras = extras || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(defaults).concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extras)).reduce(function (acc, val) {
    acc[val] = extras[val] === undefined ? defaults[val] : extras[val];
    return acc;
  }, {});
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fixed: true
    };
  },

  computed: {
    toastShow: function toastShow() {
      return this.$store.getters.toastr;
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directive__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Money',
  props: {
    validation: {
      required: false,
      defaults: false
    },
    label: {
      required: false,
      default: 'Valor Final'
    },
    rulesProp: {
      required: false
    },
    value: {
      required: true,
      default: 0
    },
    masked: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */].precision;
      }
    },
    decimal: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */].decimal;
      }
    },
    thousands: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */].thousands;
      }
    },
    prefix: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */].prefix;
      }
    },
    suffix: {
      type: String,
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */].suffix;
      }
    }
  },
  directives: { money: __WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */] },
  data: function data() {
    return {
      formattedValue: '',
      formatted: '',
      errorMessage: false,
      erroClasses: ['input-group--error', 'error--text']
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(newValue, oldValue) {
        if (newValue && newValue !== '') {
          this.formatted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* format */])(newValue, this.$props);
        } else {
          if (this.$props.validation) {
            this.formatted = '0';
          } else {
            this.formatted = '';
          }
        }

        if (this.formatted !== this.formattedValue) {
          this.formattedValue = this.formatted;
          this.formatted = '';
        }
      }
    }
  },
  methods: {
    change: function change(evt) {
      this.$emit('input', this.masked ? evt.target.value : !evt.target.value ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* unformat */])(evt.target.value, this.precision));
      // this.$emit('input', this.masked ? evt : ((!evt) ? '' : unformat(evt, this.precision)))
    },
    applyClasseDirtAndFocus: function applyClasseDirtAndFocus() {
      if (typeof this.$refs.divvmoney !== 'undefined') {
        if (this.$refs.divvmoney.classList.contains('input-group--focused')) {
          this.$refs.divvmoney.classList.remove('input-group--focused');
        }
        if (typeof this.$refs.inputvmoney !== 'undefined') {
          if (this.$refs.inputvmoney.value.length === 0) {
            if (this.$refs.divvmoney.classList.contains('input-group--dirty')) {
              this.$refs.divvmoney.classList.remove('input-group--dirty');
            }
          } else {
            this.$refs.divvmoney.classList.add('input-group--dirty');
          }
        }
        this.validationInput();
      }
    },
    onFocusApplyDirtClass: function onFocusApplyDirtClass() {
      if (this.validationRefDivMoney) {
        this.$refs.divvmoney.classList.add('input-group--focused');
        if (!this.$refs.divvmoney.classList.contains('input-group--dirty')) {
          this.$refs.divvmoney.classList.add('input-group--dirty');
        }
      }
    },
    validationInput: function validationInput() {
      var _this = this;

      if (this.$props.validation && this.validationFieldInputMoney && this.validationRefDivMoney) {
        this.erroClasses.forEach(function (element) {
          _this.$refs.divvmoney.classList.add(element);
        });
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
        this.erroClasses.forEach(function (element) {
          if (_this.$refs.divvmoney.classList.contains(element)) {
            _this.$refs.divvmoney.classList.remove(element);
          }
        });
      }
    },
    appllyRequiredClass: function appllyRequiredClass() {
      if (this.validationRefDivMoney && this.$props.validation) {
        this.$refs.divvmoney.classList.add('input-group--required');
      }
    },
    setValueDefaultForRequiredFields: function setValueDefaultForRequiredFields() {
      if (this.$props.validation) {
        this.$props.formattedValue = 0;
      }
    }
  },
  computed: {
    validationRefDivMoney: function validationRefDivMoney() {
      return typeof this.$refs.divvmoney !== 'undefined';
    },
    validationFieldInputMoney: function validationFieldInputMoney() {
      if (typeof this.$refs.inputvmoney !== 'undefined') {
        return this.$refs.inputvmoney.value.length === 0;
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    this.setValueDefaultForRequiredFields();
    this.applyClasseDirtAndFocus();
    this.appllyRequiredClass();
  },
  updated: function updated() {
    this.applyClasseDirtAndFocus();
  }
});

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 80,
	"./af.js": 80,
	"./ar": 87,
	"./ar-dz": 81,
	"./ar-dz.js": 81,
	"./ar-kw": 82,
	"./ar-kw.js": 82,
	"./ar-ly": 83,
	"./ar-ly.js": 83,
	"./ar-ma": 84,
	"./ar-ma.js": 84,
	"./ar-sa": 85,
	"./ar-sa.js": 85,
	"./ar-tn": 86,
	"./ar-tn.js": 86,
	"./ar.js": 87,
	"./az": 88,
	"./az.js": 88,
	"./be": 89,
	"./be.js": 89,
	"./bg": 90,
	"./bg.js": 90,
	"./bm": 91,
	"./bm.js": 91,
	"./bn": 92,
	"./bn.js": 92,
	"./bo": 93,
	"./bo.js": 93,
	"./br": 94,
	"./br.js": 94,
	"./bs": 95,
	"./bs.js": 95,
	"./ca": 96,
	"./ca.js": 96,
	"./cs": 97,
	"./cs.js": 97,
	"./cv": 98,
	"./cv.js": 98,
	"./cy": 99,
	"./cy.js": 99,
	"./da": 100,
	"./da.js": 100,
	"./de": 103,
	"./de-at": 101,
	"./de-at.js": 101,
	"./de-ch": 102,
	"./de-ch.js": 102,
	"./de.js": 103,
	"./dv": 104,
	"./dv.js": 104,
	"./el": 105,
	"./el.js": 105,
	"./en-SG": 106,
	"./en-SG.js": 106,
	"./en-au": 107,
	"./en-au.js": 107,
	"./en-ca": 108,
	"./en-ca.js": 108,
	"./en-gb": 109,
	"./en-gb.js": 109,
	"./en-ie": 110,
	"./en-ie.js": 110,
	"./en-il": 111,
	"./en-il.js": 111,
	"./en-nz": 112,
	"./en-nz.js": 112,
	"./eo": 113,
	"./eo.js": 113,
	"./es": 116,
	"./es-do": 114,
	"./es-do.js": 114,
	"./es-us": 115,
	"./es-us.js": 115,
	"./es.js": 116,
	"./et": 117,
	"./et.js": 117,
	"./eu": 118,
	"./eu.js": 118,
	"./fa": 119,
	"./fa.js": 119,
	"./fi": 120,
	"./fi.js": 120,
	"./fo": 121,
	"./fo.js": 121,
	"./fr": 124,
	"./fr-ca": 122,
	"./fr-ca.js": 122,
	"./fr-ch": 123,
	"./fr-ch.js": 123,
	"./fr.js": 124,
	"./fy": 125,
	"./fy.js": 125,
	"./ga": 126,
	"./ga.js": 126,
	"./gd": 127,
	"./gd.js": 127,
	"./gl": 128,
	"./gl.js": 128,
	"./gom-latn": 129,
	"./gom-latn.js": 129,
	"./gu": 130,
	"./gu.js": 130,
	"./he": 131,
	"./he.js": 131,
	"./hi": 132,
	"./hi.js": 132,
	"./hr": 133,
	"./hr.js": 133,
	"./hu": 134,
	"./hu.js": 134,
	"./hy-am": 135,
	"./hy-am.js": 135,
	"./id": 136,
	"./id.js": 136,
	"./is": 137,
	"./is.js": 137,
	"./it": 139,
	"./it-ch": 138,
	"./it-ch.js": 138,
	"./it.js": 139,
	"./ja": 140,
	"./ja.js": 140,
	"./jv": 141,
	"./jv.js": 141,
	"./ka": 142,
	"./ka.js": 142,
	"./kk": 143,
	"./kk.js": 143,
	"./km": 144,
	"./km.js": 144,
	"./kn": 145,
	"./kn.js": 145,
	"./ko": 146,
	"./ko.js": 146,
	"./ku": 147,
	"./ku.js": 147,
	"./ky": 148,
	"./ky.js": 148,
	"./lb": 149,
	"./lb.js": 149,
	"./lo": 150,
	"./lo.js": 150,
	"./lt": 151,
	"./lt.js": 151,
	"./lv": 152,
	"./lv.js": 152,
	"./me": 153,
	"./me.js": 153,
	"./mi": 154,
	"./mi.js": 154,
	"./mk": 155,
	"./mk.js": 155,
	"./ml": 156,
	"./ml.js": 156,
	"./mn": 157,
	"./mn.js": 157,
	"./mr": 158,
	"./mr.js": 158,
	"./ms": 160,
	"./ms-my": 159,
	"./ms-my.js": 159,
	"./ms.js": 160,
	"./mt": 161,
	"./mt.js": 161,
	"./my": 162,
	"./my.js": 162,
	"./nb": 163,
	"./nb.js": 163,
	"./ne": 164,
	"./ne.js": 164,
	"./nl": 166,
	"./nl-be": 165,
	"./nl-be.js": 165,
	"./nl.js": 166,
	"./nn": 167,
	"./nn.js": 167,
	"./pa-in": 168,
	"./pa-in.js": 168,
	"./pl": 169,
	"./pl.js": 169,
	"./pt": 170,
	"./pt-br": 29,
	"./pt-br.js": 29,
	"./pt.js": 170,
	"./ro": 171,
	"./ro.js": 171,
	"./ru": 172,
	"./ru.js": 172,
	"./sd": 173,
	"./sd.js": 173,
	"./se": 174,
	"./se.js": 174,
	"./si": 175,
	"./si.js": 175,
	"./sk": 176,
	"./sk.js": 176,
	"./sl": 177,
	"./sl.js": 177,
	"./sq": 178,
	"./sq.js": 178,
	"./sr": 180,
	"./sr-cyrl": 179,
	"./sr-cyrl.js": 179,
	"./sr.js": 180,
	"./ss": 181,
	"./ss.js": 181,
	"./sv": 182,
	"./sv.js": 182,
	"./sw": 183,
	"./sw.js": 183,
	"./ta": 184,
	"./ta.js": 184,
	"./te": 185,
	"./te.js": 185,
	"./tet": 186,
	"./tet.js": 186,
	"./tg": 187,
	"./tg.js": 187,
	"./th": 188,
	"./th.js": 188,
	"./tl-ph": 189,
	"./tl-ph.js": 189,
	"./tlh": 190,
	"./tlh.js": 190,
	"./tr": 191,
	"./tr.js": 191,
	"./tzl": 192,
	"./tzl.js": 192,
	"./tzm": 194,
	"./tzm-latn": 193,
	"./tzm-latn.js": 193,
	"./tzm.js": 194,
	"./ug-cn": 195,
	"./ug-cn.js": 195,
	"./uk": 196,
	"./uk.js": 196,
	"./ur": 197,
	"./ur.js": 197,
	"./uz": 199,
	"./uz-latn": 198,
	"./uz-latn.js": 198,
	"./uz.js": 199,
	"./vi": 200,
	"./vi.js": 200,
	"./x-pseudo": 201,
	"./x-pseudo.js": 201,
	"./yo": 202,
	"./yo.js": 202,
	"./zh-cn": 203,
	"./zh-cn.js": 203,
	"./zh-hk": 204,
	"./zh-hk.js": 204,
	"./zh-tw": 205,
	"./zh-tw.js": 205
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 343;

/***/ }),
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(352),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "divvmoney",
    staticClass: "prefix input-group input-group--text-field input-group--prefix primary--text"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('span', {
    staticClass: "input-group--text-field__prefix"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: ({
        precision: _vm.precision,
        decimal: _vm.decimal,
        thousands: _vm.thousands,
        prefix: _vm.prefix,
        suffix: _vm.suffix
      }),
      expression: "{precision, decimal, thousands, prefix, suffix}"
    }],
    ref: "inputvmoney",
    attrs: {
      "tabindex": "0",
      "aria-label": _vm.label,
      "type": "tel",
      "required": _vm.validation
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "change": _vm.change,
      "focus": _vm.onFocusApplyDirtClass,
      "blur": _vm.applyClasseDirtAndFocus
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group__details"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "input-group__messages input-group__error"
  }, [_vm._v("\n        Insira um valor\n      ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.toastShow.time,
      "color": _vm.toastShow.color,
      "top": true,
      "right": true
    },
    model: {
      value: (_vm.toastShow.visibility),
      callback: function($$v) {
        _vm.$set(_vm.toastShow, "visibility", $$v)
      },
      expression: "toastShow.visibility"
    }
  }, [_vm._v("\n   " + _vm._s(_vm.toastShow.text) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./pt.json": 358,
	"./yew.json": 359
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 357;

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = {"message":"hello i18n !!"}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = {"message":"hello i18n !!"}

/***/ })
]),[233]);


// WEBPACK FOOTER //
// static/js/app.1b4ac6b36726b678e73a.js